import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = {
  [X in Exclude<keyof T, K>]?: T[X];
} &
  { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents a page slug, encoded as a string with a restricted URL-safe alphabet. */
  Slug: any;
  /** Represents a URL, encoded as string */
  URL: any;
  /** Represents a monetary value in cents to avoid floating point problems, encoded as number. */
  MonetaryValue: any;
  /** Represents a currency code, encoded as string. */
  CurrencyCode: any;
  /** Date custom scalar type */
  DateTime: any;
  /** Represents the ID for a leaderboard, as a string. */
  LeaderboardId: any;
  /** Represents a page preview flag, as a boolean. */
  Preview: any;
  FixedFloat: any;
};

export type Account = {
  __typename?: 'Account';
  startDate?: Maybe<Scalars['DateTime']>;
  connectionStatus: AccountConnectionStatus;
  timeRemaining?: Maybe<AccountConnectionTimeline>;
};

export enum AccountConnectionStatus {
  Unfunded = 'UNFUNDED',
  Initialised = 'INITIALISED',
  Reminded = 'REMINDED',
  Frozen = 'FROZEN',
  ElevatedFrozen = 'ELEVATED_FROZEN',
  PseudoSuspended = 'PSEUDO_SUSPENDED',
  Deactivated = 'DEACTIVATED',
  Connected = 'CONNECTED',
  Verified = 'VERIFIED',
  PendingVerification = 'PENDING_VERIFICATION',
  ManualVerification = 'MANUAL_VERIFICATION',
}

export type AccountConnectionTimeline = {
  __typename?: 'AccountConnectionTimeline';
  next?: Maybe<TimeRemaining>;
  final?: Maybe<TimeRemaining>;
};

export type AddMediaItemInput = {
  pageId: Scalars['ID'];
  media: MediaItemInput;
  type: PageType;
};

export type AddMediaItemPayload = {
  __typename?: 'AddMediaItemPayload';
  itemId: Scalars['String'];
};

export type AggregationRule = {
  __typename?: 'AggregationRule';
  segment: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  timeBox?: Maybe<TimeBox>;
};

export type Application = FitnessApplication;

export enum ApplicationType {
  Fitness = 'FITNESS',
}

export type AsksItem = {
  __typename?: 'AsksItem';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  amountRaised?: Maybe<Scalars['MonetaryValue']>;
  target?: Maybe<Scalars['MonetaryValue']>;
  hasTarget?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['CurrencyCode']>;
  isYimby?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['String']>;
  yimbyPitchFor?: Maybe<Scalars['String']>;
  yimbyPitchBecause?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  askStatus?: Maybe<Scalars['String']>;
  editUrl?: Maybe<Scalars['String']>;
};

export type AuctionLot = Node & {
  __typename?: 'AuctionLot';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  image: ImageMedia;
  highestBid: MonetaryAmount;
  bidCount: Scalars['Int'];
  lotValue?: Maybe<MonetaryAmount>;
  isEnded: Scalars['Boolean'];
};

export type AvailableSlugs = {
  __typename?: 'AvailableSlugs';
  slugs?: Maybe<Array<Maybe<Scalars['Slug']>>>;
};

export type BeneficiaryConnection = {
  __typename?: 'BeneficiaryConnection';
  edges: Array<BeneficiaryEdge>;
  nodes: Array<BeneficiaryItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BeneficiaryEdge = {
  __typename?: 'BeneficiaryEdge';
  cursor: Scalars['String'];
  node: BeneficiaryItem;
};

export type BeneficiaryItem = Charity | User;

export type BidOnAuctionLotInput = {
  slug: Scalars['Slug'];
  lotId: Scalars['String'];
  bidAmount: MonetaryAmountInput;
  emailAddress: Scalars['String'];
};

export type BidResponse = {
  __typename?: 'BidResponse';
  successful: Scalars['Boolean'];
  lotId: Scalars['String'];
  highestBid: MonetaryAmount;
};

export type Birthday = {
  __typename?: 'Birthday';
  age?: Maybe<Scalars['Int']>;
  celebrationDate?: Maybe<Scalars['DateTime']>;
};

export type BirthdayInput = {
  age?: Maybe<Scalars['Int']>;
  celebrationDate?: Maybe<Scalars['DateTime']>;
};

export type Branding = {
  __typename?: 'Branding';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export type CancelPageInput = {
  id: Scalars['ID'];
  type: PageType;
};

export type CancelPagePayload = {
  __typename?: 'CancelPagePayload';
  page: PageWithId;
};

export type CanParticipateInInput = {
  /** ID of a team to filter by */
  teamId?: Maybe<Scalars['ID']>;
};

export type Charity = Node & {
  __typename?: 'Charity';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  slug: Scalars['Slug'];
  profilePageUrl?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['URL']>;
  impactStatement?: Maybe<Scalars['String']>;
  causeId?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['URL']>;
  targetWithCurrency?: Maybe<MonetaryAmount>;
  pageId?: Maybe<Scalars['String']>;
  legacyCharityId?: Maybe<Scalars['Int']>;
  displayCurrency?: Maybe<Scalars['String']>;
  donationPrompts?: Maybe<Array<DonationPrompt>>;
  countryCode?: Maybe<Scalars['String']>;
  thankYouMessage?: Maybe<Scalars['String']>;
};

export type ConnectFitnessInput = {
  code?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type ConsentsInput = {
  consentStatementId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  consentGiven?: Maybe<Scalars['Boolean']>;
  consentStatementText?: Maybe<Scalars['String']>;
};

export type CreateEventInput = {
  title: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  activities: Array<FitnessApplicationActivityType>;
  externalFitnessSources: Array<ExternalFitnessSources>;
  allowManualActivities: Scalars['Boolean'];
  fundraiserFitnessGoal: FitnessGoalInput;
  campaignId?: Maybe<Scalars['String']>;
};

export type CreateLivestreamInput = {
  pageType: PageType;
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
};

export type CreateOfflineDonationInput = {
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
};

export type CreatePageInput = {
  productName: Scalars['String'];
};

export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  page: PageWithId;
};

export type CreatePageV2Input = {
  celebration?: Maybe<PageCelebrationInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  product: ProductType;
  reason?: Maybe<ReasonInput>;
  relationships: Array<PageRelationshipInput>;
  slug: Scalars['Slug'];
  story?: Maybe<Scalars['String']>;
  supportsGiftAid: Scalars['Boolean'];
  tags: Array<PageTagInput>;
  target?: Maybe<MonetaryAmountInput>;
  title: Scalars['String'];
};

export type CreateTimelineEntryInput = {
  type: PageType;
  pageId: Scalars['ID'];
  pageSlug?: Maybe<Scalars['Slug']>;
  creatorGuid?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCollectionInput>;
  fitness?: Maybe<FitnessActivityInput>;
};

export type DeleteLivestreamInput = {
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  positionId: Scalars['Int'];
};

export type DeleteMediaItemInput = {
  itemId: Scalars['ID'];
  pageId: Scalars['ID'];
  type: PageType;
};

export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  itemId: Scalars['String'];
};

export type DeleteOfflineDonationInput = {
  pageId: Scalars['String'];
  offlineDonationId: Scalars['String'];
};

export enum DeleteStatus {
  Success = 'SUCCESS',
  Fail = 'FAIL',
}

export type DeleteTimelineEntryInput = {
  id: Scalars['ID'];
};

export type Distance = {
  __typename?: 'Distance';
  unit: DistanceUnit;
  value: Scalars['FixedFloat'];
};

export enum DistanceUnit {
  Metres = 'METRES',
  Feet = 'FEET',
}

export type Donation = {
  __typename?: 'Donation';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  creationDate: Scalars['DateTime'];
  amount?: Maybe<MonetaryAmount>;
  giftAidAmount?: Maybe<MonetaryAmount>;
  displayName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['URL']>;
  message?: Maybe<Scalars['String']>;
  matches: Array<DonationMatch>;
  pageOwnerReaction?: Maybe<Reaction>;
};

export type DonationConnection = {
  __typename?: 'DonationConnection';
  edges: Array<DonationEdge>;
  nodes: Array<Donation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DonationEdge = {
  __typename?: 'DonationEdge';
  cursor: Scalars['String'];
  node: Donation;
  direct: Scalars['Boolean'];
};

export type DonationMatch = {
  __typename?: 'DonationMatch';
  type: DonationMatchType;
  amount: MonetaryAmount;
};

export enum DonationMatchType {
  GiftAid = 'GIFT_AID',
  CompanyContribution = 'COMPANY_CONTRIBUTION',
}

export type DonationPrompt = {
  __typename?: 'DonationPrompt';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DonationSummary = {
  __typename?: 'DonationSummary';
  totalAmount?: Maybe<MonetaryAmount>;
  totalMatched: Array<DonationMatch>;
  onlineAmount?: Maybe<MonetaryAmount>;
  offlineAmount?: Maybe<MonetaryAmount>;
  textDonations?: Maybe<MonetaryAmount>;
  directDonationAmount?: Maybe<MonetaryAmount>;
  fundraiserRaisedAmount?: Maybe<MonetaryAmount>;
  donationCount?: Maybe<Scalars['Int']>;
  aggregatedDonationsCount?: Maybe<Scalars['Int']>;
  onlineDonationCount?: Maybe<Scalars['Int']>;
  offlineDonationCount?: Maybe<Scalars['Int']>;
};

export type Duration = {
  __typename?: 'Duration';
  unit: TimeUnit;
  value: Scalars['FixedFloat'];
};

export type EditOfflineDonationInput = {
  offlineDonationId: Scalars['String'];
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
};

export type Event = Node & {
  __typename?: 'Event';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  externalFitnessSources?: Maybe<Array<ExternalFitnessSources>>;
  allowManualActivities?: Maybe<Scalars['Boolean']>;
  fundraiserGoals?: Maybe<Array<Goal>>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventEdge>;
  nodes: Array<Event>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export enum ExternalFitnessSources {
  StravaAuto = 'STRAVA_AUTO',
  StravaManual = 'STRAVA_MANUAL',
}

export type FitnessActivity = {
  __typename?: 'FitnessActivity';
  /** @deprecated Use `activityId` as it matches the property name of the model and `id` can be confused as a `Node.ID`. */
  id?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  activityType?: Maybe<FitnessApplicationActivityType>;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Distance>;
  elevation?: Maybe<Distance>;
  duration?: Maybe<Duration>;
};

export type FitnessActivityDistanceArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityElevationArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityDurationArgs = {
  unit?: Maybe<TimeUnit>;
};

export type FitnessActivityInput = {
  title: Scalars['String'];
  activityType: FitnessApplicationActivityType;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['FixedFloat']>;
  elevation?: Maybe<Scalars['FixedFloat']>;
  duration?: Maybe<Scalars['FixedFloat']>;
};

export type FitnessApplication = {
  __typename?: 'FitnessApplication';
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<FitnessApplicationSettings>;
};

/** Fitness applications */
export enum FitnessApplicationActivityType {
  Run = 'RUN',
  Ride = 'RIDE',
  Walk = 'WALK',
  Hike = 'HIKE',
  Swim = 'SWIM',
  Wheelchair = 'WHEELCHAIR',
}

export type FitnessApplicationSettings = {
  __typename?: 'FitnessApplicationSettings';
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
  showTotaliser?: Maybe<Scalars['Boolean']>;
};

export type FitnessApplicationSettingsInput = {
  pageId: Scalars['ID'];
  name: Scalars['String'];
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
  showTotaliser?: Maybe<Scalars['Boolean']>;
};

export type FitnessGoal = {
  __typename?: 'FitnessGoal';
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  targetMetric?: Maybe<TargetMetric>;
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

export type FitnessGoalInput = {
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure: UnitOfMeasure;
};

export type Funds = {
  __typename?: 'Funds';
  accounts?: Maybe<Array<Account>>;
  withdrawals?: Maybe<WithdrawalConnection>;
};

export type FundsInput = {
  type?: Maybe<PageType>;
  slug?: Maybe<Scalars['Slug']>;
};

export type Goal = FitnessGoal;

export type Hero = {
  __typename?: 'Hero';
  imageUrl?: Maybe<Scalars['URL']>;
  imageTitle?: Maybe<Scalars['String']>;
};

export type ImageMedia = Node & {
  __typename?: 'ImageMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export type ImageMediaInput = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export type InMemory = {
  __typename?: 'InMemory';
  firstNameOfDeceased: Scalars['String'];
  lastNameOfDeceased: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
};

export type JoinTeamInput = {
  /** ID of the team to join */
  teamId: Scalars['ID'];
  /** ID of a page */
  id: Scalars['ID'];
  /** Type of page */
  type: PageType;
};

export type JoinTeamPayload = {
  __typename?: 'JoinTeamPayload';
  /** The page that is joining */
  page?: Maybe<PageWithId>;
};

export type LaunchPageInput = {
  id: Scalars['ID'];
  type: PageType;
};

export type LaunchPagePayload = {
  __typename?: 'LaunchPagePayload';
  page: PageWithId;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  id: Scalars['LeaderboardId'];
  definition?: Maybe<LeaderboardDefinition>;
  totals: Array<LeaderboardTotal>;
};

export type LeaderboardTotalsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type LeaderboardDefinition = {
  __typename?: 'LeaderboardDefinition';
  segment: Scalars['String'];
  measurementDomain: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  primaryUnit: Scalars['String'];
  tagDefinition: TagDefinition;
  conditions: Array<Tag>;
};

export type LeaderboardTotal = {
  __typename?: 'LeaderboardTotal';
  tagValue: Scalars['String'];
  tagValueAsNode?: Maybe<Node>;
  amounts: Array<TotalAmount>;
};

export type Lifecycle = {
  __typename?: 'Lifecycle';
  status?: Maybe<LifecycleStatus>;
  allowedActions?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
};

export enum LifecycleStatus {
  Draft = 'DRAFT',
  Live = 'LIVE',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}

export type Livestream = {
  __typename?: 'Livestream';
  pageType?: Maybe<PageType>;
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  entries?: Maybe<Array<Maybe<LivestreamEntries>>>;
};

export type LivestreamEntries = {
  __typename?: 'LivestreamEntries';
  mediaType?: Maybe<Scalars['String']>;
  streamId?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  positionId?: Maybe<Scalars['Int']>;
  isLive?: Maybe<Scalars['Boolean']>;
};

export type LivestreamMedia = Node & {
  __typename?: 'LivestreamMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
  /** @deprecated Use `streamPlatform` with the type LivestreamMediaPlatform */
  platform?: Maybe<Scalars['String']>;
  streamPlatform?: Maybe<LivestreamMediaPlatform>;
  streamId?: Maybe<Scalars['String']>;
};

export type LivestreamMediaInput = {
  id?: Maybe<Scalars['ID']>;
  platform?: Maybe<LivestreamMediaPlatform>;
  streamPlatform?: Maybe<LivestreamMediaPlatform>;
  streamId: Scalars['ID'];
  alt?: Maybe<Scalars['String']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export enum LivestreamMediaPlatform {
  Twitch = 'TWITCH',
  Youtube = 'YOUTUBE',
}

export type LivestreamMetaData = {
  __typename?: 'LivestreamMetaData';
  pageType?: Maybe<PageType>;
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  streamUserId: Scalars['String'];
  streamUrl: Scalars['String'];
  streamTitle: Scalars['String'];
  streamPreview: Scalars['String'];
  streamDescription: Scalars['String'];
  pageUrl: Scalars['String'];
  viewerCount: Scalars['Int'];
  isLive: Scalars['Boolean'];
};

export type Location = {
  __typename?: 'Location';
  name?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export enum MeasurementSystem {
  Metric = 'METRIC',
  Imperial = 'IMPERIAL',
}

export type Media = ImageMedia | VideoMedia | LivestreamMedia;

export type MediaCollectionInput = {
  imageMedia?: Maybe<Array<ImageMediaInput>>;
  videoMedia?: Maybe<Array<VideoMediaInput>>;
};

export type MediaConnection = {
  __typename?: 'MediaConnection';
  edges: Array<MediaEdge>;
  nodes: Array<Media>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MediaEdge = {
  __typename?: 'MediaEdge';
  cursor: Scalars['String'];
  node: Media;
};

export type MediaItemInput = {
  imageMedia?: Maybe<ImageMediaInput>;
  videoMedia?: Maybe<VideoMediaInput>;
  livestreamMedia?: Maybe<LivestreamMediaInput>;
};

export type Meta = {
  __typename?: 'Meta';
  releaseVersion: Scalars['String'];
};

/** Combines a monetary value with a currency code. */
export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  value: Scalars['MonetaryValue'];
  currencyCode: Scalars['CurrencyCode'];
};

export type MonetaryAmountInput = {
  value: Scalars['MonetaryValue'];
  currencyCode: Scalars['CurrencyCode'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * **DEPRECATED**
   * `saveFitnessApplicationSettings` Mutation is deprecated as of 26/05/2020. Use `setFitnessApplicationSettings` instead.
   */
  saveFitnessApplicationSettings?: Maybe<Scalars['Boolean']>;
  setFitnessApplicationSettings?: Maybe<FitnessApplicationSettings>;
  /** OTG 2020 - Bid on an auction lot */
  bidOnAuctionLot?: Maybe<BidResponse>;
  /** Sends a message to a donor to say thanks. */
  thankDonor?: Maybe<Donation>;
  createEvent?: Maybe<Event>;
  connectFitness: Scalars['Boolean'];
  connectFitbit: Scalars['Boolean'];
  disconnectFitness: Scalars['Boolean'];
  /** Create a new livestream entry */
  createLivestreamEntry?: Maybe<Livestream>;
  /** Delete a livestream entry */
  deleteLivestreamEntry?: Maybe<Livestream>;
  /** Update a livestream entry */
  updateLivestreamEntry?: Maybe<Livestream>;
  addOfflineDonation?: Maybe<OfflineDonation>;
  deleteOfflineDonation: Scalars['ID'];
  editOfflineDonation?: Maybe<OfflineDonation>;
  updatePage?: Maybe<UpdatePagePayload>;
  updatePreferenceService?: Maybe<PreferenceServicePayload>;
  addMediaItem?: Maybe<AddMediaItemPayload>;
  deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  launchPage?: Maybe<LaunchPagePayload>;
  cancelPage?: Maybe<CancelPagePayload>;
  setPageLifecycle?: Maybe<SetPageLifecyclePayload>;
  setPageMedia?: Maybe<SetPageMediaPayload>;
  /** @deprecated This mutation will be replaced by createPageV2 */
  createPage?: Maybe<CreatePagePayload>;
  createPageV2?: Maybe<Page>;
  addPageRelationships?: Maybe<PageRelationshipsPayload>;
  deletePageRelationships?: Maybe<PageRelationshipsPayload>;
  joinTeam?: Maybe<JoinTeamPayload>;
  unlinkTeam?: Maybe<UnlinkTeamPayload>;
  completeTask?: Maybe<Tasks>;
  /** Create a new timeline entry */
  createTimelineEntry?: Maybe<TimelineEntry>;
  deleteTimelineEntry: Scalars['ID'];
  refreshTimelineEntry: Scalars['ID'];
};

export type MutationSaveFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationSetFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationBidOnAuctionLotArgs = {
  input: BidOnAuctionLotInput;
};

export type MutationThankDonorArgs = {
  donorId: Scalars['String'];
  pageId: Scalars['String'];
  message: Scalars['String'];
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationConnectFitnessArgs = {
  input: ConnectFitnessInput;
};

export type MutationConnectFitbitArgs = {
  input: ConnectFitnessInput;
};

export type MutationCreateLivestreamEntryArgs = {
  input: CreateLivestreamInput;
};

export type MutationDeleteLivestreamEntryArgs = {
  input: DeleteLivestreamInput;
};

export type MutationUpdateLivestreamEntryArgs = {
  input: UpdateLivestreamInput;
};

export type MutationAddOfflineDonationArgs = {
  input: CreateOfflineDonationInput;
};

export type MutationDeleteOfflineDonationArgs = {
  input: DeleteOfflineDonationInput;
};

export type MutationEditOfflineDonationArgs = {
  input: EditOfflineDonationInput;
};

export type MutationUpdatePageArgs = {
  input: UpdatePageInput;
};

export type MutationUpdatePreferenceServiceArgs = {
  input: UpdatePreferenceServiceInput;
};

export type MutationAddMediaItemArgs = {
  input: AddMediaItemInput;
};

export type MutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};

export type MutationLaunchPageArgs = {
  input: LaunchPageInput;
};

export type MutationCancelPageArgs = {
  input: CancelPageInput;
};

export type MutationSetPageLifecycleArgs = {
  input: SetPageLifecycleInput;
};

export type MutationSetPageMediaArgs = {
  input: SetPageMediaInput;
};

export type MutationCreatePageArgs = {
  input: CreatePageInput;
};

export type MutationCreatePageV2Args = {
  input: CreatePageV2Input;
};

export type MutationAddPageRelationshipsArgs = {
  input: PageRelationshipsInput;
};

export type MutationDeletePageRelationshipsArgs = {
  input: PageRelationshipsInput;
};

export type MutationJoinTeamArgs = {
  input?: Maybe<JoinTeamInput>;
};

export type MutationUnlinkTeamArgs = {
  input?: Maybe<UnlinkTeamInput>;
};

export type MutationCompleteTaskArgs = {
  input?: Maybe<TaskInput>;
};

export type MutationCreateTimelineEntryArgs = {
  input: CreateTimelineEntryInput;
};

export type MutationDeleteTimelineEntryArgs = {
  input: DeleteTimelineEntryInput;
};

export type MutationRefreshTimelineEntryArgs = {
  input: RefreshTimelineEntryInput;
};

/** Marks an entity as being fetchable by its ID. */
export type Node = {
  id: Scalars['ID'];
};

export type OfflineDonation = Node & {
  __typename?: 'OfflineDonation';
  id: Scalars['ID'];
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  legacyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
};

export type OfflineDonationConnection = {
  __typename?: 'OfflineDonationConnection';
  nodes: Array<OfflineDonation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OfflineDonationEdge = {
  __typename?: 'OfflineDonationEdge';
  cursor: Scalars['String'];
  node: OfflineDonation;
};

export type Page = Node & {
  __typename?: 'Page';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  type: PageType;
  slug: Scalars['Slug'];
  url: Scalars['URL'];
  avatar?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  story?: Maybe<Scalars['String']>;
  reason?: Maybe<Reason>;
  joinVerb?: Maybe<Scalars['String']>;
  joinUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `hero` as it has `imageTitle` so you can set an image Alt. */
  heroImage?: Maybe<Scalars['URL']>;
  /** @deprecated Deprecated Nov 2019 - `hero` has been replaced by `heroMedia`. This allows a media type to be set, and to provide consistency with the `mediaCollection` field */
  hero?: Maybe<Hero>;
  heroMedia?: Maybe<Media>;
  /** @deprecated Use `targetWithCurrency.value` this will evetually become `target.value` */
  target?: Maybe<Scalars['MonetaryValue']>;
  /** @deprecated Use `targetWithCurrency.currencyCode` this will evetually become `target.currencyCode` */
  currency?: Maybe<Scalars['String']>;
  targetWithCurrency?: Maybe<MonetaryAmount>;
  donationSummary?: Maybe<DonationSummary>;
  membershipPolicy?: Maybe<Scalars['String']>;
  status?: Maybe<PageStatus>;
  createDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  updateDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  owner?: Maybe<User>;
  categories?: Maybe<Array<Scalars['String']>>;
  branding?: Maybe<Branding>;
  relationships?: Maybe<PageRelationships>;
  donations?: Maybe<DonationConnection>;
  timeline?: Maybe<TimelineEntryConnection>;
  mediaCollection?: Maybe<MediaConnection>;
  eventGivingGroupId?: Maybe<Scalars['Int']>;
  application?: Maybe<Application>;
  tags?: Maybe<Array<TagValue>>;
  redirectUrl?: Maybe<Scalars['String']>;
  livestream?: Maybe<Livestream>;
  startFundraisingUrl?: Maybe<Scalars['String']>;
  totals?: Maybe<PageTotals>;
  charity?: Maybe<Charity>;
  birthday?: Maybe<Birthday>;
  lifecycle?: Maybe<Lifecycle>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
  inMemory?: Maybe<InMemory>;
  offlineDonations?: Maybe<OfflineDonationConnection>;
};

export type PageDonationsArgs = {
  direct?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageTimelineArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  entryType?: Maybe<TimelineEntryType>;
};

export type PageMediaCollectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageApplicationArgs = {
  name: Scalars['String'];
  type: ApplicationType;
};

export type PageOfflineDonationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageCelebrationInput = {
  type: Scalars['String'];
  date: Scalars['DateTime'];
};

/** The connection type for Page. */
export type PageConnection = {
  __typename?: 'PageConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Page>>>;
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Page;
};

/** Pagination page information. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the first edge on the current page. */
  startCursor?: Maybe<Scalars['String']>;
  /** The cursor for the last edge on the current page. */
  endCursor?: Maybe<Scalars['String']>;
  /** `true` if it is possible to navigate to the next page. */
  hasNextPage: Scalars['Boolean'];
  /** `true` if it is possible to navigate to the previous page. */
  hasPreviousPage: Scalars['Boolean'];
};

export type PageRelationshipConfig = {
  __typename?: 'PageRelationshipConfig';
  membersDisabled: Scalars['Boolean'];
};

export type PageRelationshipConnection = {
  __typename?: 'PageRelationshipConnection';
  edges: Array<PageRelationshipEdge>;
  nodes: Array<Page>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PageRelationshipEdge = {
  __typename?: 'PageRelationshipEdge';
  cursor: Scalars['String'];
  node: Page;
};

export type PageRelationshipInput = {
  relatedEntityId: Scalars['String'];
  type: PageRelationshipType;
};

export type PageRelationships = {
  __typename?: 'PageRelationships';
  beneficiaries: BeneficiaryConnection;
  members: PageRelationshipConnection;
  teams: PageRelationshipConnection;
  events: EventConnection;
  campaigns: PageRelationshipConnection;
  companies: PageRelationshipConnection;
  config?: Maybe<PageRelationshipConfig>;
};

export type PageRelationshipsBeneficiariesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsMembersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsTeamsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCompaniesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsInput = {
  id: Scalars['ID'];
  beneficiaryIds?: Maybe<Array<Scalars['ID']>>;
  relatedPages?: Maybe<Array<RelatedPageInput>>;
};

export type PageRelationshipsPayload = {
  __typename?: 'PageRelationshipsPayload';
  page: PageWithId;
};

export enum PageRelationshipType {
  RaisesMoneyFor = 'RAISES_MONEY_FOR',
  HasBeneficiary = 'HAS_BENEFICIARY',
  PromotesEvent = 'PROMOTES_EVENT',
  PromotedByCampaign = 'PROMOTED_BY_CAMPAIGN',
  ParticipatesIn = 'PARTICIPATES_IN',
}

export enum PageStatus {
  Hidden = 'HIDDEN',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Offline = 'OFFLINE',
  PendingApproval = 'PENDING_APPROVAL',
  Inactive = 'INACTIVE',
}

export type PageTagInput = {
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** A single amount/metric. */
export type PageTotal = {
  __typename?: 'PageTotal';
  /** The description/id of the amount. */
  measurementDomain: Scalars['String'];
  /** Conversions in various units, for the amount. */
  amounts: Array<TotalAmount>;
};

/** A collection of numeric totals captured from the Tags System. */
export type PageTotals = {
  __typename?: 'PageTotals';
  /** Specifies the list of totals to display. */
  displayOptions: PageTotalsDisplayOptions;
  /** Specifies the primary measurement type to display totals in. */
  primaryMeasurementType: Scalars['String'];
  /** A summary of fitness/activity amounts which are present on the page timeline. */
  timeline: Array<PageTotal>;
};

export enum PageTotalsDisplayOptions {
  DoNotDisplay = 'DO_NOT_DISPLAY',
  TimelineOnly = 'TIMELINE_ONLY',
}

export enum PageType {
  Crowdfunding = 'CROWDFUNDING',
  Fundraising = 'FUNDRAISING',
  Team = 'TEAM',
  Campaign = 'CAMPAIGN',
  Charity = 'CHARITY',
  Event = 'EVENT',
  Company = 'COMPANY',
  OnePage = 'ONE_PAGE',
  InMemory = 'IN_MEMORY',
}

export type PageWithId = {
  __typename?: 'PageWithId';
  id: Scalars['ID'];
  legacyId: Scalars['ID'];
};

export type PreferenceServicePayload = {
  __typename?: 'PreferenceServicePayload';
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export enum ProductType {
  Birthday = 'BIRTHDAY',
}

export enum PublishingSource {
  Manual = 'MANUAL',
  Strava = 'STRAVA',
}

export type Query = {
  __typename?: 'Query';
  /** OTG 2020 - Get auction lots data */
  getAuctionLots?: Maybe<Array<AuctionLot>>;
  availableSlugs?: Maybe<AvailableSlugs>;
  /** Gets funds data */
  funds?: Maybe<Funds>;
  leaderboard: Leaderboard;
  livestream?: Maybe<Livestream>;
  livestreamByType?: Maybe<Array<Maybe<LivestreamMetaData>>>;
  meta: Meta;
  /** Gets page data by page type and slug or id */
  page?: Maybe<Page>;
  /**
   * Gets page data by page type and id
   * @deprecated Use the page query with an id argument type
   */
  pageById?: Maybe<Page>;
  /** Gets user data */
  viewer?: Maybe<User>;
  /** Gets node by id (node can anything that can be fetched by a unique global id, for example: page, user etc.) */
  node?: Maybe<Node>;
  tagValues: Array<TagValue>;
  tasks?: Maybe<Tasks>;
  totals: Array<Total>;
  trendingCharities?: Maybe<TrendingCharities>;
};

export type QueryGetAuctionLotsArgs = {
  slug: Scalars['Slug'];
};

export type QueryAvailableSlugsArgs = {
  slug: Scalars['Slug'];
};

export type QueryFundsArgs = {
  input?: Maybe<FundsInput>;
};

export type QueryLeaderboardArgs = {
  id: Scalars['LeaderboardId'];
};

export type QueryLivestreamArgs = {
  legacyId: Scalars['String'];
};

export type QueryLivestreamByTypeArgs = {
  streamType: Scalars['String'];
  isLive: Scalars['Boolean'];
};

export type QueryPageArgs = {
  type: PageType;
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['Slug']>;
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryPageByIdArgs = {
  type: PageType;
  id: Scalars['String'];
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryTagValuesArgs = {
  assignee: Scalars['String'];
};

export type QueryTasksArgs = {
  input?: Maybe<TaskInput>;
};

export type QueryTotalsArgs = {
  segment: Scalars['String'];
  tagDefinitionId: Scalars['String'];
  tagValue: Scalars['String'];
  measurementDomain?: Maybe<Scalars['String']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  message: Scalars['String'];
};

export type Reason = {
  __typename?: 'Reason';
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Use `description` the naming is more indicative of what it actually is */
  reason?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  reasonUrl?: Maybe<Scalars['String']>;
};

export type ReasonInput = {
  icon?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RefreshTimelineEntryInput = {
  id: Scalars['ID'];
};

export type RelatedPageInput = {
  id: Scalars['ID'];
  type: PageRelationshipType;
};

export type SetPageLifecycleInput = {
  id: Scalars['ID'];
  type: PageType;
  endDate: Scalars['DateTime'];
};

export type SetPageLifecyclePayload = {
  __typename?: 'SetPageLifecyclePayload';
  page: PageWithId;
};

export type SetPageMediaInput = {
  type: PageType;
  id: Scalars['ID'];
  media?: Maybe<MediaCollectionInput>;
};

export type SetPageMediaPayload = {
  __typename?: 'SetPageMediaPayload';
  page: PageWithId;
};

export type StoryInput = {
  content: Scalars['String'];
  type: StoryType;
};

export enum StoryType {
  RichStoryV1Json = 'RICH_STORY_V1_JSON',
  Plaintext = 'PLAINTEXT',
  Html = 'HTML',
}

export type Strava = {
  __typename?: 'Strava';
  isConnected?: Maybe<Scalars['Boolean']>;
};

export type Tag = {
  __typename?: 'Tag';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
};

export type TagDefinition = {
  __typename?: 'TagDefinition';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type TagValue = {
  __typename?: 'TagValue';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  aggregation: Array<AggregationRule>;
};

export type TagWithNode = {
  __typename?: 'TagWithNode';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  valueAsNode?: Maybe<Node>;
};

export enum TargetMetric {
  Distance = 'DISTANCE',
  Elevation = 'ELEVATION',
  Duration = 'DURATION',
}

export type TaskInput = {
  type: PageType;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
};

export type Tasks = {
  __typename?: 'Tasks';
  completed: Array<Maybe<Scalars['String']>>;
};

export type ThirdPartyApplications = {
  __typename?: 'ThirdPartyApplications';
  strava?: Maybe<Strava>;
};

export type TimeBox = {
  __typename?: 'TimeBox';
  notBefore?: Maybe<Scalars['DateTime']>;
  notAfter?: Maybe<Scalars['DateTime']>;
};

export type TimelineEntry = Node & {
  __typename?: 'TimelineEntry';
  fitnessActivity?: Maybe<FitnessActivity>;
  refreshRequestedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media>>;
  type: TimelineEntryType;
  createdAt?: Maybe<Scalars['DateTime']>;
  publishingSource?: Maybe<PublishingSource>;
};

export type TimelineEntryConnection = {
  __typename?: 'TimelineEntryConnection';
  edges: Array<TimelineEntryEdge>;
  nodes: Array<TimelineEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TimelineEntryEdge = {
  __typename?: 'TimelineEntryEdge';
  cursor: Scalars['String'];
  node: TimelineEntry;
};

export enum TimelineEntryType {
  Manual = 'MANUAL',
  Fitness = 'FITNESS',
}

export type TimeRemaining = {
  __typename?: 'TimeRemaining';
  days?: Maybe<Scalars['Int']>;
};

export enum TimeUnit {
  Milliseconds = 'MILLISECONDS',
  Seconds = 'SECONDS',
}

export type Total = {
  __typename?: 'Total';
  segment: Scalars['String'];
  segmentAsNode?: Maybe<Node>;
  tag: TagWithNode;
  measurementDomain: Scalars['String'];
  amounts: Array<TotalAmount>;
};

export type TotalAmount = {
  __typename?: 'TotalAmount';
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type TrendingCharities = {
  __typename?: 'TrendingCharities';
  edges: Array<TrendingCharitiesEdge>;
  nodes: Array<Charity>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TrendingCharitiesEdge = {
  __typename?: 'TrendingCharitiesEdge';
  cursor: Scalars['String'];
  node: Charity;
};

export enum UnitOfMeasure {
  Metres = 'METRES',
  Kilometres = 'KILOMETRES',
  Feet = 'FEET',
  Miles = 'MILES',
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  FeetClimbed = 'FEET_CLIMBED',
  MetresClimbed = 'METRES_CLIMBED',
}

export type UnlinkTeamInput = {
  /** ID of the team to unlink */
  teamId: Scalars['ID'];
  /** ID of a page */
  id: Scalars['ID'];
  /** Captain ID of a team */
  captainId?: Maybe<Scalars['ID']>;
  /** Type of page */
  type: PageType;
};

export type UnlinkTeamPayload = {
  __typename?: 'UnlinkTeamPayload';
  /** The page that is unlinking */
  page?: Maybe<PageWithId>;
};

export type UpdateLivestreamInput = {
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
  positionId: Scalars['Int'];
};

export type UpdatePageInput = {
  id: Scalars['ID'];
  type: PageType;
  slug?: Maybe<Scalars['Slug']>;
  story?: Maybe<StoryInput>;
  target?: Maybe<MonetaryAmountInput>;
  title?: Maybe<Scalars['String']>;
  birthday?: Maybe<BirthdayInput>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
};

export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  page?: Maybe<PageWithId>;
};

export type UpdatePreferenceServiceInput = {
  consents?: Maybe<Array<Maybe<ConsentsInput>>>;
  collectionLocationId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionTypeId?: Maybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  thirdPartyApplications?: Maybe<ThirdPartyApplications>;
  /** Find an page by its login that the user has permission for. */
  page?: Maybe<Page>;
  /** A list of pages that the user owns. */
  pages?: Maybe<PageConnection>;
  /** @deprecated Used only to aggregate requests for GG.Profile.Web */
  asks?: Maybe<Array<Maybe<AsksItem>>>;
};

export type UserPageArgs = {
  type: PageType;
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['Slug']>;
};

export type UserPagesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  canParticipateIn?: Maybe<CanParticipateInInput>;
  relationshipId?: Maybe<Scalars['ID']>;
};

export type UserInput = {
  name?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
};

export type VideoMedia = Node & {
  __typename?: 'VideoMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
  /** @deprecated Use `videoPlatform` with the type VideoMediaPlatform */
  platform?: Maybe<Scalars['String']>;
  videoPlatform?: Maybe<VideoMediaPlatform>;
  videoId?: Maybe<Scalars['String']>;
};

export type VideoMediaInput = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['URL']>;
  platform?: Maybe<VideoMediaPlatform>;
  videoPlatform?: Maybe<VideoMediaPlatform>;
  videoId?: Maybe<Scalars['ID']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export enum VideoMediaPlatform {
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE',
}

export type Withdrawal = {
  __typename?: 'Withdrawal';
  gross: MonetaryAmount;
  net: MonetaryAmount;
  platformFee: MonetaryAmount;
  processingFee: MonetaryAmount;
  status: WithdrawalStatus;
  completionDate?: Maybe<Scalars['DateTime']>;
  requestDate: Scalars['DateTime'];
};

export type WithdrawalConnection = {
  __typename?: 'WithdrawalConnection';
  nodes?: Maybe<Array<Withdrawal>>;
  status?: Maybe<Scalars['String']>;
  availabilityDate?: Maybe<Scalars['DateTime']>;
  totalAvailable: MonetaryAmount;
  totalWithdrawn: MonetaryAmount;
};

export enum WithdrawalStatus {
  Processing = 'PROCESSING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
}

export type AboutCampaignAndCharityQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  withExternalUrl: Scalars['Boolean'];
  beneficiariesLimit: Scalars['Int'];
}>;

export type AboutCampaignAndCharityQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & MakeOptional<
                      Pick<
                        Charity,
                        | 'id'
                        | 'legacyId'
                        | 'name'
                        | 'description'
                        | 'logo'
                        | 'registrationNumber'
                        | 'profilePageUrl'
                        | 'countryCode'
                        | 'externalUrl'
                      >,
                      'externalUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'title' | 'url' | 'logo' | 'summary'
                  >
                >;
              };
          }
        >;
      }
  >;
};

export type CauseMiniFragment = { __typename?: 'Page' } & Pick<Page, 'id'> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<
                  Charity,
                  | 'impactStatement'
                  | 'id'
                  | 'legacyId'
                  | 'logo'
                  | 'name'
                  | 'profilePageUrl'
                  | 'registrationNumber'
                  | 'slug'
                  | 'countryCode'
                >)
              | { __typename?: 'User' }
            >;
          };
        campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Page' } & Pick<
                Page,
                'id' | 'url' | 'logo' | 'title' | 'summary'
              >
            >;
          };
      }
    >;
  };

export type AboutTeamFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type AdminTabsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId'
>;

export type AuctionTotaliserWrapperFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & {
      totalAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
      >;
    }
  >;
};

export type AuctionTotalsFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<
      MonetaryAmount,
      'currencyCode' | 'value'
    >
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & Pick<
      DonationSummary,
      'aggregatedDonationsCount'
    > & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'currencyCode' | 'value'
          >
        >;
      }
  >;
  donations?: Maybe<
    { __typename?: 'DonationConnection' } & Pick<
      DonationConnection,
      'totalCount'
    >
  >;
};

export type CampaignStartFundraisingFragment = { __typename?: 'Page' } & Pick<
  Page,
  'startFundraisingUrl' | 'status'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        config?: Maybe<
          { __typename?: 'PageRelationshipConfig' } & Pick<
            PageRelationshipConfig,
            'membersDisabled'
          >
        >;
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<
                  Charity,
                  'id' | 'name' | 'profilePageUrl'
                >)
              | { __typename?: 'User' }
            >;
          };
      }
    >;
  };

export type CharityRegDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<
              Charity,
              'id' | 'registrationNumber'
            >)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type EndDateFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'endDate'
>;

export type DonationPromptsFragment = { __typename?: 'Page' } & {
  targetWithCurrency?: Maybe<
    { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currencyCode'>
  >;
  reason?: Maybe<{ __typename?: 'Reason' } & Pick<Reason, 'icon'>>;
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename: 'Charity' } & Pick<
              Charity,
              'id' | 'displayCurrency'
            > & {
                donationPrompts?: Maybe<
                  Array<
                    { __typename?: 'DonationPrompt' } & Pick<
                      DonationPrompt,
                      'amount' | 'description' | 'type'
                    >
                  >
                >;
              })
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type DonationSummaryFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        totalMatched: Array<
          { __typename?: 'DonationMatch' } & Pick<DonationMatch, 'type'> & {
              amount: { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'value' | 'currencyCode'
              >;
            }
        >;
        onlineAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        offlineAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        directDonationAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        fundraiserRaisedAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        textDonations?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
      }
    >;
  };

export type EncourageDonateOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type InactivityModalEventDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      events: { __typename?: 'EventConnection' } & Pick<
        EventConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Event' } & Pick<
              Event,
              'id' | 'startDate' | 'endDate' | 'visible'
            >
          >;
        };
    }
  >;
};

export type EncourageShareOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type EventDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'joinUrl'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        events: { __typename?: 'EventConnection' } & Pick<
          EventConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Event' } & Pick<
                Event,
                'id' | 'title' | 'startDate' | 'endDate' | 'visible'
              >
            >;
          };
      }
    >;
  };

export type FundraisersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type FundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<
                            User,
                            'id' | 'avatar' | 'name'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'value' | 'currencyCode'
                              >
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type InMemoryCharitiesListQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;

export type InMemoryCharitiesListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'slug'> & {
        inMemory?: Maybe<
          { __typename?: 'InMemory' } & Pick<InMemory, 'firstNameOfDeceased'>
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'BeneficiaryEdge' } & {
                    node:
                      | ({ __typename?: 'Charity' } & Pick<
                          Charity,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'logo'
                          | 'registrationNumber'
                          | 'profilePageUrl'
                        >)
                      | { __typename?: 'User' };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'startCursor' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type InMemoryFundraisersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type InMemoryFundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'slug'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            members: { __typename?: 'PageRelationshipConnection' } & {
              edges: Array<
                { __typename?: 'PageRelationshipEdge' } & {
                  node: { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'slug' | 'title'
                  > & {
                      heroMedia?: Maybe<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'url'
                          >)
                        | { __typename?: 'VideoMedia' }
                        | { __typename?: 'LivestreamMedia' }
                      >;
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<User, 'avatar' | 'name'>
                      >;
                      donations?: Maybe<
                        { __typename?: 'DonationConnection' } & Pick<
                          DonationConnection,
                          'totalCount'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            };
          }
        >;
      }
  >;
};

export type InMemorySupportersListQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type InMemorySupportersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'DonationEdge' } & {
                  node: { __typename?: 'Donation' } & Pick<
                    Donation,
                    | 'id'
                    | 'legacyId'
                    | 'creationDate'
                    | 'displayName'
                    | 'avatar'
                    | 'message'
                  > & {
                      amount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                      giftAidAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            }
        >;
      }
  >;
};

export type InMemoryTotalFragment = { __typename?: 'Page' } & {
  inMemory?: Maybe<
    { __typename?: 'InMemory' } & Pick<
      InMemory,
      | 'firstNameOfDeceased'
      | 'lastNameOfDeceased'
      | 'dateOfBirth'
      | 'dateOfDeath'
    >
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & {
      totalAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'currencyCode' | 'value'
        >
      >;
    }
  >;
};

export type ManualFitnessEntrySettingsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId' | 'title' | 'type' | 'slug'
> & {
    application?: Maybe<
      { __typename?: 'FitnessApplication' } & {
        settings?: Maybe<
          { __typename?: 'FitnessApplicationSettings' } & Pick<
            FitnessApplicationSettings,
            'subscribedActivities' | 'measurementSystem'
          >
        >;
      }
    >;
  };

export type MembersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type MembersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'legacyId' | 'membershipPolicy'
    > & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'url' | 'id' | 'legacyId' | 'slug' | 'title' | 'status'
                  > & {
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'id' | 'name' | 'avatar'
                        >
                      >;
                      lifecycle?: Maybe<
                        { __typename?: 'Lifecycle' } & Pick<Lifecycle, 'status'>
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                    }
                >;
              };
          }
        >;
      }
  >;
};

export type MembersMiniFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId' | 'membershipPolicy'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        members: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Page' } & Pick<Page, 'id'> & {
                  owner?: Maybe<
                    { __typename?: 'User' } & Pick<User, 'id' | 'avatar'>
                  >;
                }
            >;
          };
      }
    >;
  };

export type PageOwnerAvatarFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type QualarooLoaderDocumentQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type QualarooLoaderDocumentQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'createDate' | 'endDate' | 'currency'
    > & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<
            User,
            'id' | 'name' | 'legacyId' | 'avatar'
          >
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & Pick<
            DonationSummary,
            'donationCount'
          > & {
              offlineAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
              totalAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
            }
        >;
        heroMedia?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'id' | 'url'>)
          | { __typename?: 'VideoMedia' }
          | { __typename?: 'LivestreamMedia' }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<
                { __typename?: 'Event' } & Pick<
                  Event,
                  'id' | 'legacyId' | 'title' | 'startDate'
                >
              >;
            };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename?: 'Charity' } & Pick<
                    Charity,
                    'id' | 'legacyId'
                  >)
                | { __typename?: 'User' }
              >;
            };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
                >;
              };
            teams: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<
                { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
              >;
            };
          }
        >;
        targetWithCurrency?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & {
            nodes: Array<
              { __typename?: 'Donation' } & Pick<
                Donation,
                'id' | 'creationDate'
              >
            >;
          }
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          >
        >;
        mediaCollection?: Maybe<
          { __typename?: 'MediaConnection' } & Pick<
            MediaConnection,
            'totalCount'
          >
        >;
      }
  >;
};

export type ReasonFragment = { __typename?: 'Page' } & {
  reason?: Maybe<
    { __typename?: 'Reason' } & Pick<Reason, 'icon' | 'reason' | 'reasonUrl'>
  >;
};

export type StickySummaryFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'avatar'>>;
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
        PageRelationshipConnection,
        'totalCount'
      > & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'title'>>;
        };
    }
  >;
};

export type StoryFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'story'
>;

export type GetStravaSettingsQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type GetStravaSettingsQuery = { __typename?: 'Query' } & {
  viewer?: Maybe<
    { __typename?: 'User' } & {
      thirdPartyApplications?: Maybe<
        { __typename?: 'ThirdPartyApplications' } & {
          strava?: Maybe<
            { __typename?: 'Strava' } & Pick<Strava, 'isConnected'>
          >;
        }
      >;
    }
  >;
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'title' | 'id'> & {
        strava?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                | 'showMap'
                | 'measurementSystem'
                | 'subscribedActivities'
                | 'showPhotos'
                | 'showDuration'
                | 'showDistance'
                | 'showElevation'
                | 'showTotaliser'
              >
            >;
          }
        >;
        totals?: Maybe<
          { __typename?: 'PageTotals' } & Pick<
            PageTotals,
            'displayOptions' | 'primaryMeasurementType'
          > & {
              timeline: Array<
                { __typename?: 'PageTotal' } & Pick<
                  PageTotal,
                  'measurementDomain'
                > & {
                    amounts: Array<
                      { __typename?: 'TotalAmount' } & Pick<
                        TotalAmount,
                        'value' | 'unit'
                      >
                    >;
                  }
              >;
            }
        >;
      }
  >;
};

export type SuccessMessageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currencyCode'>
    >;
  };

export type SupportersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
}>;

export type SupportersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'DonationEdge' } & {
                  node: { __typename?: 'Donation' } & Pick<
                    Donation,
                    | 'id'
                    | 'legacyId'
                    | 'creationDate'
                    | 'displayName'
                    | 'avatar'
                    | 'message'
                  > & {
                      amount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                      giftAidAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            }
        >;
      }
  >;
};

export type TeamAndCompanyFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      teams: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<
          { __typename?: 'Page' } & Pick<
            Page,
            'id' | 'title' | 'url' | 'status'
          > & {
              heroMedia?: Maybe<
                | ({ __typename?: 'ImageMedia' } & Pick<
                    ImageMedia,
                    'id' | 'url' | 'alt'
                  >)
                | ({ __typename?: 'VideoMedia' } & Pick<VideoMedia, 'id'>)
                | ({ __typename?: 'LivestreamMedia' } & Pick<
                    LivestreamMedia,
                    'id'
                  >)
              >;
            }
        >;
      };
      companies: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<
          { __typename?: 'Page' } & Pick<Page, 'id' | 'title' | 'url' | 'logo'>
        >;
      };
    }
  >;
};

export type TeamDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<
            { __typename?: 'Page' } & Pick<
              Page,
              'id' | 'legacyId' | 'title' | 'url' | 'status'
            >
          >;
        };
      }
    >;
  };

export type TeamsListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type TeamsListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            teams: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug' | 'title'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<User, 'id' | 'avatar'>
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'currencyCode' | 'value'
                              >
                            >;
                            totalMatched: Array<
                              { __typename?: 'DonationMatch' } & Pick<
                                DonationMatch,
                                'type'
                              > & {
                                  amount: {
                                    __typename?: 'MonetaryAmount';
                                  } & Pick<
                                    MonetaryAmount,
                                    'currencyCode' | 'value'
                                  >;
                                }
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type ShareModalFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
      }
    >;
  };

export type GetStravaMeasurementSystemQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type GetStravaMeasurementSystemQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        strava?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                'measurementSystem'
              >
            >;
          }
        >;
      }
  >;
};

export type TimelineUpdateEditorFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'avatar'>>;
};

export type TotaliserWrapperFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type TotalsFragment = { __typename?: 'Page' } & Pick<Page, 'type'> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<
        MonetaryAmount,
        'currencyCode' | 'value'
      >
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & Pick<
        DonationSummary,
        'aggregatedDonationsCount'
      > & {
          totalAmount?: Maybe<
            { __typename?: 'MonetaryAmount' } & Pick<
              MonetaryAmount,
              'currencyCode' | 'value'
            >
          >;
        }
    >;
    donations?: Maybe<
      { __typename?: 'DonationConnection' } & Pick<
        DonationConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Donation' } & Pick<Donation, 'id' | 'creationDate'>
          >;
        }
    >;
  };

export type WeDidItFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'endDate'
> & {
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'currencyCode' | 'value'
          >
        >;
      }
    >;
    donations?: Maybe<
      { __typename?: 'DonationConnection' } & Pick<
        DonationConnection,
        'totalCount'
      >
    >;
  };

export type ActivityTotalsFragment = { __typename?: 'Page' } & {
  totals?: Maybe<
    { __typename?: 'PageTotals' } & Pick<
      PageTotals,
      'displayOptions' | 'primaryMeasurementType'
    > & {
        timeline: Array<
          { __typename?: 'PageTotal' } & Pick<
            PageTotal,
            'measurementDomain'
          > & {
              amounts: Array<
                { __typename?: 'TotalAmount' } & Pick<
                  TotalAmount,
                  'unit' | 'value'
                >
              >;
            }
        >;
      }
  >;
  application?: Maybe<
    { __typename?: 'FitnessApplication' } & {
      settings?: Maybe<
        { __typename?: 'FitnessApplicationSettings' } & Pick<
          FitnessApplicationSettings,
          'measurementSystem' | 'showTotaliser'
        >
      >;
    }
  >;
};

export type MediaCollectionFragment = { __typename?: 'Page' } & {
  mediaCollection?: Maybe<
    { __typename?: 'MediaConnection' } & {
      nodes: Array<
        | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'id' | 'url'>)
        | { __typename?: 'VideoMedia' }
        | { __typename?: 'LivestreamMedia' }
      >;
    }
  >;
};

export type ConnectFitnessMutationVariables = Exact<{
  input: ConnectFitnessInput;
}>;

export type ConnectFitnessMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'connectFitness'
>;

export type SetFitnessApplicationSettingsMutationVariables = Exact<{
  input: FitnessApplicationSettingsInput;
}>;

export type SetFitnessApplicationSettingsMutation = {
  __typename?: 'Mutation';
} & {
  setFitnessApplicationSettings?: Maybe<
    { __typename?: 'FitnessApplicationSettings' } & Pick<
      FitnessApplicationSettings,
      | 'measurementSystem'
      | 'subscribedActivities'
      | 'showDistance'
      | 'showDuration'
      | 'showElevation'
      | 'showPhotos'
      | 'showMap'
      | 'showTotaliser'
    >
  >;
};

export type CreateTimelineEntryMutationVariables = Exact<{
  input: CreateTimelineEntryInput;
  measurementSystem?: Maybe<MeasurementSystem>;
}>;

export type CreateTimelineEntryMutation = { __typename?: 'Mutation' } & {
  createTimelineEntry?: Maybe<
    { __typename?: 'TimelineEntry' } & Pick<
      TimelineEntry,
      'id' | 'legacyId' | 'message' | 'type' | 'createdAt' | 'publishingSource'
    > & {
        media?: Maybe<
          Array<
            | ({ __typename?: 'ImageMedia' } & Pick<
                ImageMedia,
                'id' | 'url' | 'legacyId'
              >)
            | { __typename?: 'VideoMedia' }
            | { __typename?: 'LivestreamMedia' }
          >
        >;
        fitnessActivity?: Maybe<
          { __typename?: 'FitnessActivity' } & Pick<
            FitnessActivity,
            'id' | 'activityId' | 'title' | 'activityType' | 'mapPolyline'
          > & {
              distance?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              elevation?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              duration?: Maybe<
                { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
              >;
            }
        >;
      }
  >;
};

export type DeleteTimelineEntryMutationVariables = Exact<{
  input: DeleteTimelineEntryInput;
}>;

export type DeleteTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'deleteTimelineEntry'
>;

export type ListTimelineEntriesQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  type: PageType;
  slug: Scalars['Slug'];
  measurementSystem?: Maybe<MeasurementSystem>;
  entryType?: Maybe<TimelineEntryType>;
}>;

export type ListTimelineEntriesQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'> & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          > & {
              nodes: Array<
                { __typename?: 'TimelineEntry' } & Pick<
                  TimelineEntry,
                  | 'id'
                  | 'legacyId'
                  | 'message'
                  | 'type'
                  | 'createdAt'
                  | 'refreshRequestedTime'
                  | 'publishingSource'
                > & {
                    media?: Maybe<
                      Array<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'id' | 'url' | 'legacyId'
                          >)
                        | { __typename?: 'VideoMedia' }
                        | { __typename?: 'LivestreamMedia' }
                      >
                    >;
                    fitnessActivity?: Maybe<
                      { __typename?: 'FitnessActivity' } & Pick<
                        FitnessActivity,
                        'activityId' | 'title' | 'activityType' | 'mapPolyline'
                      > & {
                          distance?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          elevation?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          duration?: Maybe<
                            { __typename?: 'Duration' } & Pick<
                              Duration,
                              'unit' | 'value'
                            >
                          >;
                        }
                    >;
                  }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
              >;
            }
        >;
      }
  >;
};

export type RefreshTimelineEntryMutationVariables = Exact<{
  input: RefreshTimelineEntryInput;
}>;

export type RefreshTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'refreshTimelineEntry'
>;

export type UseBidOnAuctionQueryVariables = Exact<{
  slug: Scalars['Slug'];
}>;

export type UseBidOnAuctionQuery = { __typename?: 'Query' } & {
  getAuctionLots?: Maybe<
    Array<
      { __typename?: 'AuctionLot' } & Pick<
        AuctionLot,
        'legacyId' | 'title' | 'description' | 'isEnded'
      > & {
          image: { __typename?: 'ImageMedia' } & Pick<ImageMedia, 'url'>;
          highestBid: { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >;
          lotValue?: Maybe<
            { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
          >;
        }
    >
  >;
};

export type BidOnAuctionLotMutationVariables = Exact<{
  input: BidOnAuctionLotInput;
}>;

export type BidOnAuctionLotMutation = { __typename?: 'Mutation' } & {
  bidOnAuctionLot?: Maybe<
    { __typename?: 'BidResponse' } & Pick<
      BidResponse,
      'successful' | 'lotId'
    > & {
        highestBid: { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'value' | 'currencyCode'
        >;
      }
  >;
};

export type BypassAmountPageEnrolmentQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  isFundraisingPage: Scalars['Boolean'];
}>;

export type BypassAmountPageEnrolmentQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & {
            totalAmount?: Maybe<
              { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'currencyCode'
              >
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & MakeOptional<
                      Pick<Charity, 'id' | 'countryCode'>,
                      'countryCode'
                    >)
                  | ({ __typename?: 'User' } & Pick<User, 'id'>)
                >;
              };
          }
        >;
      }
  >;
};

export type IsCharityAdminFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'legacyId'>)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type IsPageOwnerFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId'
> & {
    owner?: Maybe<
      { __typename?: 'User' } & Pick<User, 'id' | 'legacyId' | 'name'>
    >;
  };

export type PageIdFragment = { __typename?: 'Page' } & Pick<Page, 'id'>;

export type FirstToDonateEnrolmentFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<
        MonetaryAmount,
        'currencyCode' | 'value'
      >
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type AuctionPageQueryVariables = Exact<{
  slug: Scalars['Slug'];
}>;

export type AuctionPageQuery = { __typename?: 'Query' } & {
  getAuctionLots?: Maybe<
    Array<
      { __typename?: 'AuctionLot' } & Pick<
        AuctionLot,
        'legacyId' | 'title' | 'description' | 'isEnded'
      > & {
          image: { __typename?: 'ImageMedia' } & Pick<ImageMedia, 'url'>;
          highestBid: { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >;
          lotValue?: Maybe<
            { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
          >;
        }
    >
  >;
};

export type FundraisingPageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title' | 'eventGivingGroupId'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
        companies: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        >;
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'status'>>;
        };
        campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'slug'>>;
          };
      }
    >;
  };

export type BasePageDataQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  includeEvent?: Maybe<Scalars['Boolean']>;
}>;

export type BasePageDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      | 'id'
      | 'status'
      | 'legacyId'
      | 'title'
      | 'summary'
      | 'logo'
      | 'type'
      | 'url'
      | 'redirectUrl'
      | 'startFundraisingUrl'
      | 'joinUrl'
    > & {
        heroMedia?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<
              ImageMedia,
              'id' | 'url' | 'alt' | 'caption'
            >)
          | { __typename?: 'VideoMedia' }
          | ({ __typename?: 'LivestreamMedia' } & Pick<
              LivestreamMedia,
              'id' | 'url' | 'platform' | 'streamId'
            >)
        >;
        hero?: Maybe<
          { __typename?: 'Hero' } & Pick<Hero, 'imageUrl' | 'imageTitle'>
        >;
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        mediaCollection?: Maybe<
          { __typename?: 'MediaConnection' } & {
            nodes: Array<
              | ({ __typename?: 'ImageMedia' } & Pick<
                  ImageMedia,
                  'id' | 'url' | 'caption'
                >)
              | { __typename?: 'VideoMedia' }
              | { __typename?: 'LivestreamMedia' }
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            events: { __typename?: 'EventConnection' } & Pick<
              EventConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Event' } & Pick<
                    Event,
                    'id' | 'title' | 'startDate' | 'endDate' | 'visible'
                  >
                >;
              };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & Pick<
                      Charity,
                      | 'id'
                      | 'legacyId'
                      | 'name'
                      | 'countryCode'
                      | 'profilePageUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
                >;
              };
          }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'id' | 'name' | 'legacyId'>
        >;
        reason?: Maybe<
          { __typename?: 'Reason' } & Pick<
            Reason,
            'icon' | 'reason' | 'reasonUrl'
          >
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            | 'primaryColor'
            | 'backgroundColor'
            | 'backgroundImage'
            | 'logo'
            | 'headerImage'
          >
        >;
        lifecycle?: Maybe<
          { __typename?: 'Lifecycle' } & Pick<
            Lifecycle,
            'status' | 'allowedActions' | 'updatedDate' | 'expiryDate'
          >
        >;
      }
  >;
};

export type DonateDataQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type DonateDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'eventGivingGroupId' | 'legacyId' | 'title' | 'slug'
    > & {
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        heroMedia?: Maybe<
          | ({ __typename: 'ImageMedia' } & Pick<ImageMedia, 'url'>)
          | { __typename?: 'VideoMedia' }
          | { __typename?: 'LivestreamMedia' }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<
            User,
            'id' | 'name' | 'avatar' | 'legacyId'
          >
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            'primaryColor' | 'headerImage'
          >
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & {
            totalAmount?: Maybe<
              { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'currencyCode'
              >
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename: 'Charity' } & Pick<
                    Charity,
                    | 'id'
                    | 'legacyId'
                    | 'name'
                    | 'logo'
                    | 'causeId'
                    | 'legacyCharityId'
                    | 'profilePageUrl'
                    | 'displayCurrency'
                    | 'thankYouMessage'
                    | 'countryCode'
                  > & {
                      donationPrompts?: Maybe<
                        Array<
                          { __typename?: 'DonationPrompt' } & Pick<
                            DonationPrompt,
                            'amount' | 'description' | 'type'
                          >
                        >
                      >;
                    })
                | { __typename?: 'User' }
              >;
            };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
                >;
              };
            teams: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<
                { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
              >;
            };
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<
                { __typename?: 'Event' } & Pick<Event, 'id' | 'legacyId'>
              >;
            };
          }
        >;
        lifecycle?: Maybe<
          { __typename?: 'Lifecycle' } & Pick<Lifecycle, 'status'>
        >;
      }
  >;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {}
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>;
  Slug: ResolverTypeWrapper<Scalars['Slug']>;
  AuctionLot: ResolverTypeWrapper<AuctionLot>;
  Node:
    | ResolversTypes['AuctionLot']
    | ResolversTypes['ImageMedia']
    | ResolversTypes['Page']
    | ResolversTypes['VideoMedia']
    | ResolversTypes['LivestreamMedia']
    | ResolversTypes['User']
    | ResolversTypes['Charity']
    | ResolversTypes['Event']
    | ResolversTypes['TimelineEntry']
    | ResolversTypes['OfflineDonation'];
  ID: ResolverTypeWrapper<Scalars['ID']>;
  String: ResolverTypeWrapper<Scalars['String']>;
  ImageMedia: ResolverTypeWrapper<ImageMedia>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  URL: ResolverTypeWrapper<Scalars['URL']>;
  MonetaryAmount: ResolverTypeWrapper<MonetaryAmount>;
  MonetaryValue: ResolverTypeWrapper<Scalars['MonetaryValue']>;
  CurrencyCode: ResolverTypeWrapper<Scalars['CurrencyCode']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  AvailableSlugs: ResolverTypeWrapper<AvailableSlugs>;
  FundsInput: FundsInput;
  PageType: PageType;
  Funds: ResolverTypeWrapper<Funds>;
  Account: ResolverTypeWrapper<Account>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  AccountConnectionStatus: AccountConnectionStatus;
  AccountConnectionTimeline: ResolverTypeWrapper<AccountConnectionTimeline>;
  TimeRemaining: ResolverTypeWrapper<TimeRemaining>;
  WithdrawalConnection: ResolverTypeWrapper<WithdrawalConnection>;
  Withdrawal: ResolverTypeWrapper<Withdrawal>;
  WithdrawalStatus: WithdrawalStatus;
  LeaderboardId: ResolverTypeWrapper<Scalars['LeaderboardId']>;
  Leaderboard: ResolverTypeWrapper<Leaderboard>;
  LeaderboardDefinition: ResolverTypeWrapper<LeaderboardDefinition>;
  TagDefinition: ResolverTypeWrapper<TagDefinition>;
  Tag: ResolverTypeWrapper<Tag>;
  LeaderboardTotal: ResolverTypeWrapper<LeaderboardTotal>;
  TotalAmount: ResolverTypeWrapper<TotalAmount>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Livestream: ResolverTypeWrapper<Livestream>;
  LivestreamEntries: ResolverTypeWrapper<LivestreamEntries>;
  LivestreamMetaData: ResolverTypeWrapper<LivestreamMetaData>;
  Meta: ResolverTypeWrapper<Meta>;
  Preview: ResolverTypeWrapper<Scalars['Preview']>;
  Page: ResolverTypeWrapper<
    Omit<Page, 'heroMedia' | 'application'> & {
      heroMedia?: Maybe<ResolversTypes['Media']>;
      application?: Maybe<ResolversTypes['Application']>;
    }
  >;
  Reason: ResolverTypeWrapper<Reason>;
  Hero: ResolverTypeWrapper<Hero>;
  Media:
    | ResolversTypes['ImageMedia']
    | ResolversTypes['VideoMedia']
    | ResolversTypes['LivestreamMedia'];
  VideoMedia: ResolverTypeWrapper<VideoMedia>;
  VideoMediaPlatform: VideoMediaPlatform;
  LivestreamMedia: ResolverTypeWrapper<LivestreamMedia>;
  LivestreamMediaPlatform: LivestreamMediaPlatform;
  DonationSummary: ResolverTypeWrapper<DonationSummary>;
  DonationMatch: ResolverTypeWrapper<DonationMatch>;
  DonationMatchType: DonationMatchType;
  PageStatus: PageStatus;
  Location: ResolverTypeWrapper<Location>;
  User: ResolverTypeWrapper<User>;
  ThirdPartyApplications: ResolverTypeWrapper<ThirdPartyApplications>;
  Strava: ResolverTypeWrapper<Strava>;
  CanParticipateInInput: CanParticipateInInput;
  PageConnection: ResolverTypeWrapper<PageConnection>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageEdge: ResolverTypeWrapper<PageEdge>;
  AsksItem: ResolverTypeWrapper<AsksItem>;
  Branding: ResolverTypeWrapper<Branding>;
  PageRelationships: ResolverTypeWrapper<PageRelationships>;
  BeneficiaryConnection: ResolverTypeWrapper<
    Omit<BeneficiaryConnection, 'nodes'> & {
      nodes: Array<ResolversTypes['BeneficiaryItem']>;
    }
  >;
  BeneficiaryEdge: ResolverTypeWrapper<
    Omit<BeneficiaryEdge, 'node'> & { node: ResolversTypes['BeneficiaryItem'] }
  >;
  BeneficiaryItem: ResolversTypes['Charity'] | ResolversTypes['User'];
  Charity: ResolverTypeWrapper<Charity>;
  DonationPrompt: ResolverTypeWrapper<DonationPrompt>;
  PageRelationshipConnection: ResolverTypeWrapper<PageRelationshipConnection>;
  PageRelationshipEdge: ResolverTypeWrapper<PageRelationshipEdge>;
  EventConnection: ResolverTypeWrapper<EventConnection>;
  EventEdge: ResolverTypeWrapper<EventEdge>;
  Event: ResolverTypeWrapper<
    Omit<Event, 'fundraiserGoals'> & {
      fundraiserGoals?: Maybe<Array<ResolversTypes['Goal']>>;
    }
  >;
  FitnessApplicationActivityType: FitnessApplicationActivityType;
  ExternalFitnessSources: ExternalFitnessSources;
  Goal: ResolversTypes['FitnessGoal'];
  FitnessGoal: ResolverTypeWrapper<FitnessGoal>;
  TargetMetric: TargetMetric;
  UnitOfMeasure: UnitOfMeasure;
  PageRelationshipConfig: ResolverTypeWrapper<PageRelationshipConfig>;
  DonationConnection: ResolverTypeWrapper<DonationConnection>;
  DonationEdge: ResolverTypeWrapper<DonationEdge>;
  Donation: ResolverTypeWrapper<Donation>;
  Reaction: ResolverTypeWrapper<Reaction>;
  TimelineEntryType: TimelineEntryType;
  TimelineEntryConnection: ResolverTypeWrapper<TimelineEntryConnection>;
  TimelineEntryEdge: ResolverTypeWrapper<TimelineEntryEdge>;
  TimelineEntry: ResolverTypeWrapper<
    Omit<TimelineEntry, 'media'> & {
      media?: Maybe<Array<ResolversTypes['Media']>>;
    }
  >;
  FitnessActivity: ResolverTypeWrapper<FitnessActivity>;
  MeasurementSystem: MeasurementSystem;
  Distance: ResolverTypeWrapper<Distance>;
  DistanceUnit: DistanceUnit;
  FixedFloat: ResolverTypeWrapper<Scalars['FixedFloat']>;
  TimeUnit: TimeUnit;
  Duration: ResolverTypeWrapper<Duration>;
  PublishingSource: PublishingSource;
  MediaConnection: ResolverTypeWrapper<
    Omit<MediaConnection, 'nodes'> & { nodes: Array<ResolversTypes['Media']> }
  >;
  MediaEdge: ResolverTypeWrapper<
    Omit<MediaEdge, 'node'> & { node: ResolversTypes['Media'] }
  >;
  ApplicationType: ApplicationType;
  Application: ResolversTypes['FitnessApplication'];
  FitnessApplication: ResolverTypeWrapper<FitnessApplication>;
  FitnessApplicationSettings: ResolverTypeWrapper<FitnessApplicationSettings>;
  TagValue: ResolverTypeWrapper<TagValue>;
  AggregationRule: ResolverTypeWrapper<AggregationRule>;
  TimeBox: ResolverTypeWrapper<TimeBox>;
  PageTotals: ResolverTypeWrapper<PageTotals>;
  PageTotalsDisplayOptions: PageTotalsDisplayOptions;
  PageTotal: ResolverTypeWrapper<PageTotal>;
  Birthday: ResolverTypeWrapper<Birthday>;
  Lifecycle: ResolverTypeWrapper<Lifecycle>;
  LifecycleStatus: LifecycleStatus;
  InMemory: ResolverTypeWrapper<InMemory>;
  OfflineDonationConnection: ResolverTypeWrapper<OfflineDonationConnection>;
  OfflineDonation: ResolverTypeWrapper<OfflineDonation>;
  TaskInput: TaskInput;
  Tasks: ResolverTypeWrapper<Tasks>;
  Total: ResolverTypeWrapper<Total>;
  TagWithNode: ResolverTypeWrapper<TagWithNode>;
  TrendingCharities: ResolverTypeWrapper<TrendingCharities>;
  TrendingCharitiesEdge: ResolverTypeWrapper<TrendingCharitiesEdge>;
  Mutation: ResolverTypeWrapper<{}>;
  FitnessApplicationSettingsInput: FitnessApplicationSettingsInput;
  BidOnAuctionLotInput: BidOnAuctionLotInput;
  MonetaryAmountInput: MonetaryAmountInput;
  BidResponse: ResolverTypeWrapper<BidResponse>;
  CreateEventInput: CreateEventInput;
  FitnessGoalInput: FitnessGoalInput;
  ConnectFitnessInput: ConnectFitnessInput;
  CreateLivestreamInput: CreateLivestreamInput;
  DeleteLivestreamInput: DeleteLivestreamInput;
  UpdateLivestreamInput: UpdateLivestreamInput;
  CreateOfflineDonationInput: CreateOfflineDonationInput;
  DeleteOfflineDonationInput: DeleteOfflineDonationInput;
  EditOfflineDonationInput: EditOfflineDonationInput;
  UpdatePageInput: UpdatePageInput;
  StoryInput: StoryInput;
  StoryType: StoryType;
  BirthdayInput: BirthdayInput;
  UpdatePagePayload: ResolverTypeWrapper<UpdatePagePayload>;
  PageWithId: ResolverTypeWrapper<PageWithId>;
  UpdatePreferenceServiceInput: UpdatePreferenceServiceInput;
  ConsentsInput: ConsentsInput;
  PreferenceServicePayload: ResolverTypeWrapper<PreferenceServicePayload>;
  AddMediaItemInput: AddMediaItemInput;
  MediaItemInput: MediaItemInput;
  ImageMediaInput: ImageMediaInput;
  VideoMediaInput: VideoMediaInput;
  LivestreamMediaInput: LivestreamMediaInput;
  AddMediaItemPayload: ResolverTypeWrapper<AddMediaItemPayload>;
  DeleteMediaItemInput: DeleteMediaItemInput;
  DeleteMediaItemPayload: ResolverTypeWrapper<DeleteMediaItemPayload>;
  LaunchPageInput: LaunchPageInput;
  LaunchPagePayload: ResolverTypeWrapper<LaunchPagePayload>;
  CancelPageInput: CancelPageInput;
  CancelPagePayload: ResolverTypeWrapper<CancelPagePayload>;
  SetPageLifecycleInput: SetPageLifecycleInput;
  SetPageLifecyclePayload: ResolverTypeWrapper<SetPageLifecyclePayload>;
  SetPageMediaInput: SetPageMediaInput;
  MediaCollectionInput: MediaCollectionInput;
  SetPageMediaPayload: ResolverTypeWrapper<SetPageMediaPayload>;
  CreatePageInput: CreatePageInput;
  CreatePagePayload: ResolverTypeWrapper<CreatePagePayload>;
  CreatePageV2Input: CreatePageV2Input;
  PageCelebrationInput: PageCelebrationInput;
  ProductType: ProductType;
  ReasonInput: ReasonInput;
  PageRelationshipInput: PageRelationshipInput;
  PageRelationshipType: PageRelationshipType;
  PageTagInput: PageTagInput;
  PageRelationshipsInput: PageRelationshipsInput;
  RelatedPageInput: RelatedPageInput;
  PageRelationshipsPayload: ResolverTypeWrapper<PageRelationshipsPayload>;
  JoinTeamInput: JoinTeamInput;
  JoinTeamPayload: ResolverTypeWrapper<JoinTeamPayload>;
  UnlinkTeamInput: UnlinkTeamInput;
  UnlinkTeamPayload: ResolverTypeWrapper<UnlinkTeamPayload>;
  CreateTimelineEntryInput: CreateTimelineEntryInput;
  FitnessActivityInput: FitnessActivityInput;
  DeleteTimelineEntryInput: DeleteTimelineEntryInput;
  RefreshTimelineEntryInput: RefreshTimelineEntryInput;
  CacheControlScope: CacheControlScope;
  DeleteStatus: DeleteStatus;
  OfflineDonationEdge: ResolverTypeWrapper<OfflineDonationEdge>;
  UserInput: UserInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {};
  Slug: Scalars['Slug'];
  AuctionLot: AuctionLot;
  Node:
    | ResolversParentTypes['AuctionLot']
    | ResolversParentTypes['ImageMedia']
    | ResolversParentTypes['Page']
    | ResolversParentTypes['VideoMedia']
    | ResolversParentTypes['LivestreamMedia']
    | ResolversParentTypes['User']
    | ResolversParentTypes['Charity']
    | ResolversParentTypes['Event']
    | ResolversParentTypes['TimelineEntry']
    | ResolversParentTypes['OfflineDonation'];
  ID: Scalars['ID'];
  String: Scalars['String'];
  ImageMedia: ImageMedia;
  Int: Scalars['Int'];
  URL: Scalars['URL'];
  MonetaryAmount: MonetaryAmount;
  MonetaryValue: Scalars['MonetaryValue'];
  CurrencyCode: Scalars['CurrencyCode'];
  Boolean: Scalars['Boolean'];
  AvailableSlugs: AvailableSlugs;
  FundsInput: FundsInput;
  Funds: Funds;
  Account: Account;
  DateTime: Scalars['DateTime'];
  AccountConnectionTimeline: AccountConnectionTimeline;
  TimeRemaining: TimeRemaining;
  WithdrawalConnection: WithdrawalConnection;
  Withdrawal: Withdrawal;
  LeaderboardId: Scalars['LeaderboardId'];
  Leaderboard: Leaderboard;
  LeaderboardDefinition: LeaderboardDefinition;
  TagDefinition: TagDefinition;
  Tag: Tag;
  LeaderboardTotal: LeaderboardTotal;
  TotalAmount: TotalAmount;
  Float: Scalars['Float'];
  Livestream: Livestream;
  LivestreamEntries: LivestreamEntries;
  LivestreamMetaData: LivestreamMetaData;
  Meta: Meta;
  Preview: Scalars['Preview'];
  Page: Omit<Page, 'heroMedia' | 'application'> & {
    heroMedia?: Maybe<ResolversParentTypes['Media']>;
    application?: Maybe<ResolversParentTypes['Application']>;
  };
  Reason: Reason;
  Hero: Hero;
  Media:
    | ResolversParentTypes['ImageMedia']
    | ResolversParentTypes['VideoMedia']
    | ResolversParentTypes['LivestreamMedia'];
  VideoMedia: VideoMedia;
  LivestreamMedia: LivestreamMedia;
  DonationSummary: DonationSummary;
  DonationMatch: DonationMatch;
  Location: Location;
  User: User;
  ThirdPartyApplications: ThirdPartyApplications;
  Strava: Strava;
  CanParticipateInInput: CanParticipateInInput;
  PageConnection: PageConnection;
  PageInfo: PageInfo;
  PageEdge: PageEdge;
  AsksItem: AsksItem;
  Branding: Branding;
  PageRelationships: PageRelationships;
  BeneficiaryConnection: Omit<BeneficiaryConnection, 'nodes'> & {
    nodes: Array<ResolversParentTypes['BeneficiaryItem']>;
  };
  BeneficiaryEdge: Omit<BeneficiaryEdge, 'node'> & {
    node: ResolversParentTypes['BeneficiaryItem'];
  };
  BeneficiaryItem:
    | ResolversParentTypes['Charity']
    | ResolversParentTypes['User'];
  Charity: Charity;
  DonationPrompt: DonationPrompt;
  PageRelationshipConnection: PageRelationshipConnection;
  PageRelationshipEdge: PageRelationshipEdge;
  EventConnection: EventConnection;
  EventEdge: EventEdge;
  Event: Omit<Event, 'fundraiserGoals'> & {
    fundraiserGoals?: Maybe<Array<ResolversParentTypes['Goal']>>;
  };
  Goal: ResolversParentTypes['FitnessGoal'];
  FitnessGoal: FitnessGoal;
  PageRelationshipConfig: PageRelationshipConfig;
  DonationConnection: DonationConnection;
  DonationEdge: DonationEdge;
  Donation: Donation;
  Reaction: Reaction;
  TimelineEntryConnection: TimelineEntryConnection;
  TimelineEntryEdge: TimelineEntryEdge;
  TimelineEntry: Omit<TimelineEntry, 'media'> & {
    media?: Maybe<Array<ResolversParentTypes['Media']>>;
  };
  FitnessActivity: FitnessActivity;
  Distance: Distance;
  FixedFloat: Scalars['FixedFloat'];
  Duration: Duration;
  MediaConnection: Omit<MediaConnection, 'nodes'> & {
    nodes: Array<ResolversParentTypes['Media']>;
  };
  MediaEdge: Omit<MediaEdge, 'node'> & { node: ResolversParentTypes['Media'] };
  Application: ResolversParentTypes['FitnessApplication'];
  FitnessApplication: FitnessApplication;
  FitnessApplicationSettings: FitnessApplicationSettings;
  TagValue: TagValue;
  AggregationRule: AggregationRule;
  TimeBox: TimeBox;
  PageTotals: PageTotals;
  PageTotal: PageTotal;
  Birthday: Birthday;
  Lifecycle: Lifecycle;
  InMemory: InMemory;
  OfflineDonationConnection: OfflineDonationConnection;
  OfflineDonation: OfflineDonation;
  TaskInput: TaskInput;
  Tasks: Tasks;
  Total: Total;
  TagWithNode: TagWithNode;
  TrendingCharities: TrendingCharities;
  TrendingCharitiesEdge: TrendingCharitiesEdge;
  Mutation: {};
  FitnessApplicationSettingsInput: FitnessApplicationSettingsInput;
  BidOnAuctionLotInput: BidOnAuctionLotInput;
  MonetaryAmountInput: MonetaryAmountInput;
  BidResponse: BidResponse;
  CreateEventInput: CreateEventInput;
  FitnessGoalInput: FitnessGoalInput;
  ConnectFitnessInput: ConnectFitnessInput;
  CreateLivestreamInput: CreateLivestreamInput;
  DeleteLivestreamInput: DeleteLivestreamInput;
  UpdateLivestreamInput: UpdateLivestreamInput;
  CreateOfflineDonationInput: CreateOfflineDonationInput;
  DeleteOfflineDonationInput: DeleteOfflineDonationInput;
  EditOfflineDonationInput: EditOfflineDonationInput;
  UpdatePageInput: UpdatePageInput;
  StoryInput: StoryInput;
  BirthdayInput: BirthdayInput;
  UpdatePagePayload: UpdatePagePayload;
  PageWithId: PageWithId;
  UpdatePreferenceServiceInput: UpdatePreferenceServiceInput;
  ConsentsInput: ConsentsInput;
  PreferenceServicePayload: PreferenceServicePayload;
  AddMediaItemInput: AddMediaItemInput;
  MediaItemInput: MediaItemInput;
  ImageMediaInput: ImageMediaInput;
  VideoMediaInput: VideoMediaInput;
  LivestreamMediaInput: LivestreamMediaInput;
  AddMediaItemPayload: AddMediaItemPayload;
  DeleteMediaItemInput: DeleteMediaItemInput;
  DeleteMediaItemPayload: DeleteMediaItemPayload;
  LaunchPageInput: LaunchPageInput;
  LaunchPagePayload: LaunchPagePayload;
  CancelPageInput: CancelPageInput;
  CancelPagePayload: CancelPagePayload;
  SetPageLifecycleInput: SetPageLifecycleInput;
  SetPageLifecyclePayload: SetPageLifecyclePayload;
  SetPageMediaInput: SetPageMediaInput;
  MediaCollectionInput: MediaCollectionInput;
  SetPageMediaPayload: SetPageMediaPayload;
  CreatePageInput: CreatePageInput;
  CreatePagePayload: CreatePagePayload;
  CreatePageV2Input: CreatePageV2Input;
  PageCelebrationInput: PageCelebrationInput;
  ReasonInput: ReasonInput;
  PageRelationshipInput: PageRelationshipInput;
  PageTagInput: PageTagInput;
  PageRelationshipsInput: PageRelationshipsInput;
  RelatedPageInput: RelatedPageInput;
  PageRelationshipsPayload: PageRelationshipsPayload;
  JoinTeamInput: JoinTeamInput;
  JoinTeamPayload: JoinTeamPayload;
  UnlinkTeamInput: UnlinkTeamInput;
  UnlinkTeamPayload: UnlinkTeamPayload;
  CreateTimelineEntryInput: CreateTimelineEntryInput;
  FitnessActivityInput: FitnessActivityInput;
  DeleteTimelineEntryInput: DeleteTimelineEntryInput;
  RefreshTimelineEntryInput: RefreshTimelineEntryInput;
  OfflineDonationEdge: OfflineDonationEdge;
  UserInput: UserInput;
};

export type ComplexityDirectiveArgs = {
  value: Scalars['Int'];
  multipliers?: Maybe<Array<Scalars['String']>>;
};

export type ComplexityDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ComplexityDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type CacheControlDirectiveArgs = {
  maxAge?: Maybe<Scalars['Int']>;
  scope?: Maybe<CacheControlScope>;
};

export type CacheControlDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = CacheControlDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']
> = {
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  connectionStatus?: Resolver<
    ResolversTypes['AccountConnectionStatus'],
    ParentType,
    ContextType
  >;
  timeRemaining?: Resolver<
    Maybe<ResolversTypes['AccountConnectionTimeline']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountConnectionTimelineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountConnectionTimeline'] = ResolversParentTypes['AccountConnectionTimeline']
> = {
  next?: Resolver<
    Maybe<ResolversTypes['TimeRemaining']>,
    ParentType,
    ContextType
  >;
  final?: Resolver<
    Maybe<ResolversTypes['TimeRemaining']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddMediaItemPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddMediaItemPayload'] = ResolversParentTypes['AddMediaItemPayload']
> = {
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AggregationRule'] = ResolversParentTypes['AggregationRule']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  measurementDomains?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  timeBox?: Resolver<Maybe<ResolversTypes['TimeBox']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Application'] = ResolversParentTypes['Application']
> = {
  __resolveType: TypeResolveFn<'FitnessApplication', ParentType, ContextType>;
};

export type AsksItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AsksItem'] = ResolversParentTypes['AsksItem']
> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountRaised?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  target?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  hasTarget?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  currency?: Resolver<
    Maybe<ResolversTypes['CurrencyCode']>,
    ParentType,
    ContextType
  >;
  isYimby?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yimbyPitchFor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  yimbyPitchBecause?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  beneficiaryName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  askStatus?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  editUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuctionLotResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuctionLot'] = ResolversParentTypes['AuctionLot']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['ImageMedia'], ParentType, ContextType>;
  highestBid?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  bidCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lotValue?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  isEnded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableSlugsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AvailableSlugs'] = ResolversParentTypes['AvailableSlugs']
> = {
  slugs?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Slug']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryConnection'] = ResolversParentTypes['BeneficiaryConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['BeneficiaryEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes['BeneficiaryItem']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryEdge'] = ResolversParentTypes['BeneficiaryEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BeneficiaryItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryItem'] = ResolversParentTypes['BeneficiaryItem']
> = {
  __resolveType: TypeResolveFn<'Charity' | 'User', ParentType, ContextType>;
};

export type BidResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BidResponse'] = ResolversParentTypes['BidResponse']
> = {
  successful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lotId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  highestBid?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BirthdayResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Birthday'] = ResolversParentTypes['Birthday']
> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  celebrationDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Branding'] = ResolversParentTypes['Branding']
> = {
  backgroundColor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  backgroundImage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headerImage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  primaryColor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelPagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelPagePayload'] = ResolversParentTypes['CancelPagePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CharityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Charity'] = ResolversParentTypes['Charity']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  registrationNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes['Slug'], ParentType, ContextType>;
  profilePageUrl?: Resolver<
    Maybe<ResolversTypes['URL']>,
    ParentType,
    ContextType
  >;
  logo?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  impactStatement?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  causeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  targetWithCurrency?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  pageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyCharityId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  displayCurrency?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  donationPrompts?: Resolver<
    Maybe<Array<ResolversTypes['DonationPrompt']>>,
    ParentType,
    ContextType
  >;
  countryCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  thankYouMessage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CreatePagePayload'] = ResolversParentTypes['CreatePagePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CurrencyCodeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['CurrencyCode'], any> {
  name: 'CurrencyCode';
}

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeleteMediaItemPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteMediaItemPayload'] = ResolversParentTypes['DeleteMediaItemPayload']
> = {
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Distance'] = ResolversParentTypes['Distance']
> = {
  unit?: Resolver<ResolversTypes['DistanceUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FixedFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Donation'] = ResolversParentTypes['Donation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  amount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  giftAidAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  displayName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matches?: Resolver<
    Array<ResolversTypes['DonationMatch']>,
    ParentType,
    ContextType
  >;
  pageOwnerReaction?: Resolver<
    Maybe<ResolversTypes['Reaction']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationConnection'] = ResolversParentTypes['DonationConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['DonationEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Donation']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationEdge'] = ResolversParentTypes['DonationEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Donation'], ParentType, ContextType>;
  direct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationMatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationMatch'] = ResolversParentTypes['DonationMatch']
> = {
  type?: Resolver<ResolversTypes['DonationMatchType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationPromptResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationPrompt'] = ResolversParentTypes['DonationPrompt']
> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationSummary'] = ResolversParentTypes['DonationSummary']
> = {
  totalAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  totalMatched?: Resolver<
    Array<ResolversTypes['DonationMatch']>,
    ParentType,
    ContextType
  >;
  onlineAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  offlineAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  textDonations?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  directDonationAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  fundraiserRaisedAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  donationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  aggregatedDonationsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  onlineDonationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  offlineDonationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Duration'] = ResolversParentTypes['Duration']
> = {
  unit?: Resolver<ResolversTypes['TimeUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FixedFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  activities?: Resolver<
    Maybe<Array<ResolversTypes['FitnessApplicationActivityType']>>,
    ParentType,
    ContextType
  >;
  externalFitnessSources?: Resolver<
    Maybe<Array<ResolversTypes['ExternalFitnessSources']>>,
    ParentType,
    ContextType
  >;
  allowManualActivities?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  fundraiserGoals?: Resolver<
    Maybe<Array<ResolversTypes['Goal']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventConnection'] = ResolversParentTypes['EventConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['EventEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Event']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventEdge'] = ResolversParentTypes['EventEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Event'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessActivityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessActivity'] = ResolversParentTypes['FitnessActivity']
> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityType?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationActivityType']>,
    ParentType,
    ContextType
  >;
  mapPolyline?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  distance?: Resolver<
    Maybe<ResolversTypes['Distance']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityDistanceArgs, 'measurementSystem'>
  >;
  elevation?: Resolver<
    Maybe<ResolversTypes['Distance']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityElevationArgs, 'measurementSystem'>
  >;
  duration?: Resolver<
    Maybe<ResolversTypes['Duration']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityDurationArgs, 'unit'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessApplicationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessApplication'] = ResolversParentTypes['FitnessApplication']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationSettings']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessApplicationSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessApplicationSettings'] = ResolversParentTypes['FitnessApplicationSettings']
> = {
  measurementSystem?: Resolver<
    Maybe<ResolversTypes['MeasurementSystem']>,
    ParentType,
    ContextType
  >;
  subscribedActivities?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['FitnessApplicationActivityType']>>>,
    ParentType,
    ContextType
  >;
  showDistance?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showDuration?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showElevation?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showPhotos?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showMap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showTotaliser?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessGoalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessGoal'] = ResolversParentTypes['FitnessGoal']
> = {
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  activities?: Resolver<
    Maybe<Array<ResolversTypes['FitnessApplicationActivityType']>>,
    ParentType,
    ContextType
  >;
  targetMetric?: Resolver<
    Maybe<ResolversTypes['TargetMetric']>,
    ParentType,
    ContextType
  >;
  targetAmount?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  unitOfMeasure?: Resolver<
    Maybe<ResolversTypes['UnitOfMeasure']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface FixedFloatScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['FixedFloat'], any> {
  name: 'FixedFloat';
}

export type FundsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Funds'] = ResolversParentTypes['Funds']
> = {
  accounts?: Resolver<
    Maybe<Array<ResolversTypes['Account']>>,
    ParentType,
    ContextType
  >;
  withdrawals?: Resolver<
    Maybe<ResolversTypes['WithdrawalConnection']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GoalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Goal'] = ResolversParentTypes['Goal']
> = {
  __resolveType: TypeResolveFn<'FitnessGoal', ParentType, ContextType>;
};

export type HeroResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Hero'] = ResolversParentTypes['Hero']
> = {
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  imageTitle?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ImageMedia'] = ResolversParentTypes['ImageMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InMemoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InMemory'] = ResolversParentTypes['InMemory']
> = {
  firstNameOfDeceased?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  lastNameOfDeceased?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  dateOfBirth?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  dateOfDeath?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JoinTeamPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JoinTeamPayload'] = ResolversParentTypes['JoinTeamPayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LaunchPagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LaunchPagePayload'] = ResolversParentTypes['LaunchPagePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Leaderboard'] = ResolversParentTypes['Leaderboard']
> = {
  id?: Resolver<ResolversTypes['LeaderboardId'], ParentType, ContextType>;
  definition?: Resolver<
    Maybe<ResolversTypes['LeaderboardDefinition']>,
    ParentType,
    ContextType
  >;
  totals?: Resolver<
    Array<ResolversTypes['LeaderboardTotal']>,
    ParentType,
    ContextType,
    RequireFields<LeaderboardTotalsArgs, 'limit'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LeaderboardDefinition'] = ResolversParentTypes['LeaderboardDefinition']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  measurementDomains?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  primaryUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  conditions?: Resolver<Array<ResolversTypes['Tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LeaderboardIdScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['LeaderboardId'], any> {
  name: 'LeaderboardId';
}

export type LeaderboardTotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LeaderboardTotal'] = ResolversParentTypes['LeaderboardTotal']
> = {
  tagValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagValueAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LifecycleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Lifecycle'] = ResolversParentTypes['Lifecycle']
> = {
  status?: Resolver<
    Maybe<ResolversTypes['LifecycleStatus']>,
    ParentType,
    ContextType
  >;
  allowedActions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  updatedDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  expiryDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Livestream'] = ResolversParentTypes['Livestream']
> = {
  pageType?: Resolver<
    Maybe<ResolversTypes['PageType']>,
    ParentType,
    ContextType
  >;
  mediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entries?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LivestreamEntries']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamEntriesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamEntries'] = ResolversParentTypes['LivestreamEntries']
> = {
  mediaType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  streamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  positionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamMedia'] = ResolversParentTypes['LivestreamMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  posterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamPlatform?: Resolver<
    Maybe<ResolversTypes['LivestreamMediaPlatform']>,
    ParentType,
    ContextType
  >;
  streamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamMetaDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamMetaData'] = ResolversParentTypes['LivestreamMetaData']
> = {
  pageType?: Resolver<
    Maybe<ResolversTypes['PageType']>,
    ParentType,
    ContextType
  >;
  mediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamPreview?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamDescription?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  pageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']
> = {
  __resolveType: TypeResolveFn<
    'ImageMedia' | 'VideoMedia' | 'LivestreamMedia',
    ParentType,
    ContextType
  >;
};

export type MediaConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MediaConnection'] = ResolversParentTypes['MediaConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['MediaEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MediaEdge'] = ResolversParentTypes['MediaEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Media'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Meta'] = ResolversParentTypes['Meta']
> = {
  releaseVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonetaryAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MonetaryAmount'] = ResolversParentTypes['MonetaryAmount']
> = {
  value?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  currencyCode?: Resolver<
    ResolversTypes['CurrencyCode'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MonetaryValueScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['MonetaryValue'], any> {
  name: 'MonetaryValue';
}

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']
> = {
  saveFitnessApplicationSettings?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationSaveFitnessApplicationSettingsArgs, 'input'>
  >;
  setFitnessApplicationSettings?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationSettings']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetFitnessApplicationSettingsArgs, 'input'>
  >;
  bidOnAuctionLot?: Resolver<
    Maybe<ResolversTypes['BidResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationBidOnAuctionLotArgs, 'input'>
  >;
  thankDonor?: Resolver<
    Maybe<ResolversTypes['Donation']>,
    ParentType,
    ContextType,
    RequireFields<MutationThankDonorArgs, 'donorId' | 'pageId' | 'message'>
  >;
  createEvent?: Resolver<
    Maybe<ResolversTypes['Event']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateEventArgs, 'input'>
  >;
  connectFitness?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationConnectFitnessArgs, 'input'>
  >;
  connectFitbit?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationConnectFitbitArgs, 'input'>
  >;
  disconnectFitness?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  createLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateLivestreamEntryArgs, 'input'>
  >;
  deleteLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLivestreamEntryArgs, 'input'>
  >;
  updateLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLivestreamEntryArgs, 'input'>
  >;
  addOfflineDonation?: Resolver<
    Maybe<ResolversTypes['OfflineDonation']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddOfflineDonationArgs, 'input'>
  >;
  deleteOfflineDonation?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteOfflineDonationArgs, 'input'>
  >;
  editOfflineDonation?: Resolver<
    Maybe<ResolversTypes['OfflineDonation']>,
    ParentType,
    ContextType,
    RequireFields<MutationEditOfflineDonationArgs, 'input'>
  >;
  updatePage?: Resolver<
    Maybe<ResolversTypes['UpdatePagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePageArgs, 'input'>
  >;
  updatePreferenceService?: Resolver<
    Maybe<ResolversTypes['PreferenceServicePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePreferenceServiceArgs, 'input'>
  >;
  addMediaItem?: Resolver<
    Maybe<ResolversTypes['AddMediaItemPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddMediaItemArgs, 'input'>
  >;
  deleteMediaItem?: Resolver<
    Maybe<ResolversTypes['DeleteMediaItemPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMediaItemArgs, 'input'>
  >;
  launchPage?: Resolver<
    Maybe<ResolversTypes['LaunchPagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLaunchPageArgs, 'input'>
  >;
  cancelPage?: Resolver<
    Maybe<ResolversTypes['CancelPagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCancelPageArgs, 'input'>
  >;
  setPageLifecycle?: Resolver<
    Maybe<ResolversTypes['SetPageLifecyclePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetPageLifecycleArgs, 'input'>
  >;
  setPageMedia?: Resolver<
    Maybe<ResolversTypes['SetPageMediaPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetPageMediaArgs, 'input'>
  >;
  createPage?: Resolver<
    Maybe<ResolversTypes['CreatePagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePageArgs, 'input'>
  >;
  createPageV2?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePageV2Args, 'input'>
  >;
  addPageRelationships?: Resolver<
    Maybe<ResolversTypes['PageRelationshipsPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddPageRelationshipsArgs, 'input'>
  >;
  deletePageRelationships?: Resolver<
    Maybe<ResolversTypes['PageRelationshipsPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeletePageRelationshipsArgs, 'input'>
  >;
  joinTeam?: Resolver<
    Maybe<ResolversTypes['JoinTeamPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationJoinTeamArgs, never>
  >;
  unlinkTeam?: Resolver<
    Maybe<ResolversTypes['UnlinkTeamPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUnlinkTeamArgs, never>
  >;
  completeTask?: Resolver<
    Maybe<ResolversTypes['Tasks']>,
    ParentType,
    ContextType,
    RequireFields<MutationCompleteTaskArgs, never>
  >;
  createTimelineEntry?: Resolver<
    Maybe<ResolversTypes['TimelineEntry']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTimelineEntryArgs, 'input'>
  >;
  deleteTimelineEntry?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTimelineEntryArgs, 'input'>
  >;
  refreshTimelineEntry?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationRefreshTimelineEntryArgs, 'input'>
  >;
};

export type NodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']
> = {
  __resolveType: TypeResolveFn<
    | 'AuctionLot'
    | 'ImageMedia'
    | 'Page'
    | 'VideoMedia'
    | 'LivestreamMedia'
    | 'User'
    | 'Charity'
    | 'Event'
    | 'TimelineEntry'
    | 'OfflineDonation',
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type OfflineDonationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonation'] = ResolversParentTypes['OfflineDonation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  displayName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineDonationConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonationConnection'] = ResolversParentTypes['OfflineDonationConnection']
> = {
  nodes?: Resolver<
    Array<ResolversTypes['OfflineDonation']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineDonationEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonationEdge'] = ResolversParentTypes['OfflineDonationEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OfflineDonation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PageType'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['Slug'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  story?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  joinVerb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  joinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroImage?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['Hero']>, ParentType, ContextType>;
  heroMedia?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  target?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetWithCurrency?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  donationSummary?: Resolver<
    Maybe<ResolversTypes['DonationSummary']>,
    ParentType,
    ContextType
  >;
  membershipPolicy?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    Maybe<ResolversTypes['PageStatus']>,
    ParentType,
    ContextType
  >;
  createDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updateDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  location?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  categories?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  branding?: Resolver<
    Maybe<ResolversTypes['Branding']>,
    ParentType,
    ContextType
  >;
  relationships?: Resolver<
    Maybe<ResolversTypes['PageRelationships']>,
    ParentType,
    ContextType
  >;
  donations?: Resolver<
    Maybe<ResolversTypes['DonationConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageDonationsArgs, never>
  >;
  timeline?: Resolver<
    Maybe<ResolversTypes['TimelineEntryConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageTimelineArgs, never>
  >;
  mediaCollection?: Resolver<
    Maybe<ResolversTypes['MediaConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageMediaCollectionArgs, never>
  >;
  eventGivingGroupId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  application?: Resolver<
    Maybe<ResolversTypes['Application']>,
    ParentType,
    ContextType,
    RequireFields<PageApplicationArgs, 'name' | 'type'>
  >;
  tags?: Resolver<
    Maybe<Array<ResolversTypes['TagValue']>>,
    ParentType,
    ContextType
  >;
  redirectUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  livestream?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType
  >;
  startFundraisingUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  totals?: Resolver<
    Maybe<ResolversTypes['PageTotals']>,
    ParentType,
    ContextType
  >;
  charity?: Resolver<Maybe<ResolversTypes['Charity']>, ParentType, ContextType>;
  birthday?: Resolver<
    Maybe<ResolversTypes['Birthday']>,
    ParentType,
    ContextType
  >;
  lifecycle?: Resolver<
    Maybe<ResolversTypes['Lifecycle']>,
    ParentType,
    ContextType
  >;
  supportsGiftAid?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  inMemory?: Resolver<
    Maybe<ResolversTypes['InMemory']>,
    ParentType,
    ContextType
  >;
  offlineDonations?: Resolver<
    Maybe<ResolversTypes['OfflineDonationConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageOfflineDonationsArgs, never>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageConnection'] = ResolversParentTypes['PageConnection']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['PageEdge']>>>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Page']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageEdge'] = ResolversParentTypes['PageEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']
> = {
  startCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  endCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipConfig'] = ResolversParentTypes['PageRelationshipConfig']
> = {
  membersDisabled?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipConnection'] = ResolversParentTypes['PageRelationshipConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['PageRelationshipEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipEdge'] = ResolversParentTypes['PageRelationshipEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationships'] = ResolversParentTypes['PageRelationships']
> = {
  beneficiaries?: Resolver<
    ResolversTypes['BeneficiaryConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsBeneficiariesArgs, never>
  >;
  members?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsMembersArgs, never>
  >;
  teams?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsTeamsArgs, never>
  >;
  events?: Resolver<
    ResolversTypes['EventConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsEventsArgs, never>
  >;
  campaigns?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsCampaignsArgs, never>
  >;
  companies?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsCompaniesArgs, never>
  >;
  config?: Resolver<
    Maybe<ResolversTypes['PageRelationshipConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipsPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipsPayload'] = ResolversParentTypes['PageRelationshipsPayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageTotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageTotal'] = ResolversParentTypes['PageTotal']
> = {
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageTotalsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageTotals'] = ResolversParentTypes['PageTotals']
> = {
  displayOptions?: Resolver<
    ResolversTypes['PageTotalsDisplayOptions'],
    ParentType,
    ContextType
  >;
  primaryMeasurementType?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  timeline?: Resolver<
    Array<ResolversTypes['PageTotal']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageWithIdResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageWithId'] = ResolversParentTypes['PageWithId']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreferenceServicePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PreferenceServicePayload'] = ResolversParentTypes['PreferenceServicePayload']
> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PreviewScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Preview'], any> {
  name: 'Preview';
}

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']
> = {
  getAuctionLots?: Resolver<
    Maybe<Array<ResolversTypes['AuctionLot']>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetAuctionLotsArgs, 'slug'>
  >;
  availableSlugs?: Resolver<
    Maybe<ResolversTypes['AvailableSlugs']>,
    ParentType,
    ContextType,
    RequireFields<QueryAvailableSlugsArgs, 'slug'>
  >;
  funds?: Resolver<
    Maybe<ResolversTypes['Funds']>,
    ParentType,
    ContextType,
    RequireFields<QueryFundsArgs, never>
  >;
  leaderboard?: Resolver<
    ResolversTypes['Leaderboard'],
    ParentType,
    ContextType,
    RequireFields<QueryLeaderboardArgs, 'id'>
  >;
  livestream?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<QueryLivestreamArgs, 'legacyId'>
  >;
  livestreamByType?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LivestreamMetaData']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryLivestreamByTypeArgs, 'streamType' | 'isLive'>
  >;
  meta?: Resolver<ResolversTypes['Meta'], ParentType, ContextType>;
  page?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<QueryPageArgs, 'type'>
  >;
  pageById?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<QueryPageByIdArgs, 'type' | 'id'>
  >;
  viewer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  node?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType,
    RequireFields<QueryNodeArgs, 'id'>
  >;
  tagValues?: Resolver<
    Array<ResolversTypes['TagValue']>,
    ParentType,
    ContextType,
    RequireFields<QueryTagValuesArgs, 'assignee'>
  >;
  tasks?: Resolver<
    Maybe<ResolversTypes['Tasks']>,
    ParentType,
    ContextType,
    RequireFields<QueryTasksArgs, never>
  >;
  totals?: Resolver<
    Array<ResolversTypes['Total']>,
    ParentType,
    ContextType,
    RequireFields<QueryTotalsArgs, 'segment' | 'tagDefinitionId' | 'tagValue'>
  >;
  trendingCharities?: Resolver<
    Maybe<ResolversTypes['TrendingCharities']>,
    ParentType,
    ContextType
  >;
};

export type ReactionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Reaction'] = ResolversParentTypes['Reaction']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Reason'] = ResolversParentTypes['Reason']
> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  reasonUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPageLifecyclePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetPageLifecyclePayload'] = ResolversParentTypes['SetPageLifecyclePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPageMediaPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetPageMediaPayload'] = ResolversParentTypes['SetPageMediaPayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface SlugScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Slug'], any> {
  name: 'Slug';
}

export type StravaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Strava'] = ResolversParentTypes['Strava']
> = {
  isConnected?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagDefinition'] = ResolversParentTypes['TagDefinition']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagValueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagValue'] = ResolversParentTypes['TagValue']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  aggregation?: Resolver<
    Array<ResolversTypes['AggregationRule']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagWithNodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagWithNode'] = ResolversParentTypes['TagWithNode']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tasks'] = ResolversParentTypes['Tasks']
> = {
  completed?: Resolver<
    Array<Maybe<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThirdPartyApplicationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ThirdPartyApplications'] = ResolversParentTypes['ThirdPartyApplications']
> = {
  strava?: Resolver<Maybe<ResolversTypes['Strava']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeBoxResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeBox'] = ResolversParentTypes['TimeBox']
> = {
  notBefore?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  notAfter?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntry'] = ResolversParentTypes['TimelineEntry']
> = {
  fitnessActivity?: Resolver<
    Maybe<ResolversTypes['FitnessActivity']>,
    ParentType,
    ContextType
  >;
  refreshRequestedTime?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  media?: Resolver<
    Maybe<Array<ResolversTypes['Media']>>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['TimelineEntryType'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  publishingSource?: Resolver<
    Maybe<ResolversTypes['PublishingSource']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntryConnection'] = ResolversParentTypes['TimelineEntryConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['TimelineEntryEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes['TimelineEntry']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntryEdge'] = ResolversParentTypes['TimelineEntryEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TimelineEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeRemainingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeRemaining'] = ResolversParentTypes['TimeRemaining']
> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Total'] = ResolversParentTypes['Total']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  segmentAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  tag?: Resolver<ResolversTypes['TagWithNode'], ParentType, ContextType>;
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotalAmount'] = ResolversParentTypes['TotalAmount']
> = {
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingCharitiesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrendingCharities'] = ResolversParentTypes['TrendingCharities']
> = {
  edges?: Resolver<
    Array<ResolversTypes['TrendingCharitiesEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Charity']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingCharitiesEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrendingCharitiesEdge'] = ResolversParentTypes['TrendingCharitiesEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Charity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnlinkTeamPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnlinkTeamPayload'] = ResolversParentTypes['UnlinkTeamPayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdatePagePayload'] = ResolversParentTypes['UpdatePagePayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UrlScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thirdPartyApplications?: Resolver<
    Maybe<ResolversTypes['ThirdPartyApplications']>,
    ParentType,
    ContextType
  >;
  page?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<UserPageArgs, 'type'>
  >;
  pages?: Resolver<
    Maybe<ResolversTypes['PageConnection']>,
    ParentType,
    ContextType,
    RequireFields<UserPagesArgs, never>
  >;
  asks?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AsksItem']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VideoMedia'] = ResolversParentTypes['VideoMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  posterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPlatform?: Resolver<
    Maybe<ResolversTypes['VideoMediaPlatform']>,
    ParentType,
    ContextType
  >;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Withdrawal'] = ResolversParentTypes['Withdrawal']
> = {
  gross?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  net?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  platformFee?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  processingFee?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes['WithdrawalStatus'],
    ParentType,
    ContextType
  >;
  completionDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  requestDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WithdrawalConnection'] = ResolversParentTypes['WithdrawalConnection']
> = {
  nodes?: Resolver<
    Maybe<Array<ResolversTypes['Withdrawal']>>,
    ParentType,
    ContextType
  >;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availabilityDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  totalAvailable?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  totalWithdrawn?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Account?: AccountResolvers<ContextType>;
  AccountConnectionTimeline?: AccountConnectionTimelineResolvers<ContextType>;
  AddMediaItemPayload?: AddMediaItemPayloadResolvers<ContextType>;
  AggregationRule?: AggregationRuleResolvers<ContextType>;
  Application?: ApplicationResolvers<ContextType>;
  AsksItem?: AsksItemResolvers<ContextType>;
  AuctionLot?: AuctionLotResolvers<ContextType>;
  AvailableSlugs?: AvailableSlugsResolvers<ContextType>;
  BeneficiaryConnection?: BeneficiaryConnectionResolvers<ContextType>;
  BeneficiaryEdge?: BeneficiaryEdgeResolvers<ContextType>;
  BeneficiaryItem?: BeneficiaryItemResolvers<ContextType>;
  BidResponse?: BidResponseResolvers<ContextType>;
  Birthday?: BirthdayResolvers<ContextType>;
  Branding?: BrandingResolvers<ContextType>;
  CancelPagePayload?: CancelPagePayloadResolvers<ContextType>;
  Charity?: CharityResolvers<ContextType>;
  CreatePagePayload?: CreatePagePayloadResolvers<ContextType>;
  CurrencyCode?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeleteMediaItemPayload?: DeleteMediaItemPayloadResolvers<ContextType>;
  Distance?: DistanceResolvers<ContextType>;
  Donation?: DonationResolvers<ContextType>;
  DonationConnection?: DonationConnectionResolvers<ContextType>;
  DonationEdge?: DonationEdgeResolvers<ContextType>;
  DonationMatch?: DonationMatchResolvers<ContextType>;
  DonationPrompt?: DonationPromptResolvers<ContextType>;
  DonationSummary?: DonationSummaryResolvers<ContextType>;
  Duration?: DurationResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  EventConnection?: EventConnectionResolvers<ContextType>;
  EventEdge?: EventEdgeResolvers<ContextType>;
  FitnessActivity?: FitnessActivityResolvers<ContextType>;
  FitnessApplication?: FitnessApplicationResolvers<ContextType>;
  FitnessApplicationSettings?: FitnessApplicationSettingsResolvers<ContextType>;
  FitnessGoal?: FitnessGoalResolvers<ContextType>;
  FixedFloat?: GraphQLScalarType;
  Funds?: FundsResolvers<ContextType>;
  Goal?: GoalResolvers<ContextType>;
  Hero?: HeroResolvers<ContextType>;
  ImageMedia?: ImageMediaResolvers<ContextType>;
  InMemory?: InMemoryResolvers<ContextType>;
  JoinTeamPayload?: JoinTeamPayloadResolvers<ContextType>;
  LaunchPagePayload?: LaunchPagePayloadResolvers<ContextType>;
  Leaderboard?: LeaderboardResolvers<ContextType>;
  LeaderboardDefinition?: LeaderboardDefinitionResolvers<ContextType>;
  LeaderboardId?: GraphQLScalarType;
  LeaderboardTotal?: LeaderboardTotalResolvers<ContextType>;
  Lifecycle?: LifecycleResolvers<ContextType>;
  Livestream?: LivestreamResolvers<ContextType>;
  LivestreamEntries?: LivestreamEntriesResolvers<ContextType>;
  LivestreamMedia?: LivestreamMediaResolvers<ContextType>;
  LivestreamMetaData?: LivestreamMetaDataResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MediaConnection?: MediaConnectionResolvers<ContextType>;
  MediaEdge?: MediaEdgeResolvers<ContextType>;
  Meta?: MetaResolvers<ContextType>;
  MonetaryAmount?: MonetaryAmountResolvers<ContextType>;
  MonetaryValue?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  OfflineDonation?: OfflineDonationResolvers<ContextType>;
  OfflineDonationConnection?: OfflineDonationConnectionResolvers<ContextType>;
  OfflineDonationEdge?: OfflineDonationEdgeResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageConnection?: PageConnectionResolvers<ContextType>;
  PageEdge?: PageEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PageRelationshipConfig?: PageRelationshipConfigResolvers<ContextType>;
  PageRelationshipConnection?: PageRelationshipConnectionResolvers<ContextType>;
  PageRelationshipEdge?: PageRelationshipEdgeResolvers<ContextType>;
  PageRelationships?: PageRelationshipsResolvers<ContextType>;
  PageRelationshipsPayload?: PageRelationshipsPayloadResolvers<ContextType>;
  PageTotal?: PageTotalResolvers<ContextType>;
  PageTotals?: PageTotalsResolvers<ContextType>;
  PageWithId?: PageWithIdResolvers<ContextType>;
  PreferenceServicePayload?: PreferenceServicePayloadResolvers<ContextType>;
  Preview?: GraphQLScalarType;
  Query?: QueryResolvers<ContextType>;
  Reaction?: ReactionResolvers<ContextType>;
  Reason?: ReasonResolvers<ContextType>;
  SetPageLifecyclePayload?: SetPageLifecyclePayloadResolvers<ContextType>;
  SetPageMediaPayload?: SetPageMediaPayloadResolvers<ContextType>;
  Slug?: GraphQLScalarType;
  Strava?: StravaResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  TagDefinition?: TagDefinitionResolvers<ContextType>;
  TagValue?: TagValueResolvers<ContextType>;
  TagWithNode?: TagWithNodeResolvers<ContextType>;
  Tasks?: TasksResolvers<ContextType>;
  ThirdPartyApplications?: ThirdPartyApplicationsResolvers<ContextType>;
  TimeBox?: TimeBoxResolvers<ContextType>;
  TimelineEntry?: TimelineEntryResolvers<ContextType>;
  TimelineEntryConnection?: TimelineEntryConnectionResolvers<ContextType>;
  TimelineEntryEdge?: TimelineEntryEdgeResolvers<ContextType>;
  TimeRemaining?: TimeRemainingResolvers<ContextType>;
  Total?: TotalResolvers<ContextType>;
  TotalAmount?: TotalAmountResolvers<ContextType>;
  TrendingCharities?: TrendingCharitiesResolvers<ContextType>;
  TrendingCharitiesEdge?: TrendingCharitiesEdgeResolvers<ContextType>;
  UnlinkTeamPayload?: UnlinkTeamPayloadResolvers<ContextType>;
  UpdatePagePayload?: UpdatePagePayloadResolvers<ContextType>;
  URL?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  VideoMedia?: VideoMediaResolvers<ContextType>;
  Withdrawal?: WithdrawalResolvers<ContextType>;
  WithdrawalConnection?: WithdrawalConnectionResolvers<ContextType>;
};

/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  complexity?: ComplexityDirectiveResolver<any, any, ContextType>;
  cacheControl?: CacheControlDirectiveResolver<any, any, ContextType>;
};

/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<
  ContextType
>;
